var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 738.874,
    height: 586.837,
    viewBox: "0 0 738.874 586.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data_report-pana",
    "data-name": "Data report-pana",
    transform: "translate(-36.214 115.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    transform: "translate(36.213 -78.295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 6.34,
    height: 47.436,
    transform: "translate(485.739 379.794) rotate(-90)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M472.565,299.42a15.151,15.151,0,0,1,0,5.934,14.6,14.6,0,0,1,0-5.934Z",
    transform: "translate(19.639 74.294)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M471.643,299.31a15.147,15.147,0,0,1,0,5.934A15.15,15.15,0,0,1,471.643,299.31Z",
    transform: "translate(19.522 74.28)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M505.623,299.42a14.6,14.6,0,0,1,0,5.934A15.151,15.151,0,0,1,505.623,299.42Z",
    transform: "translate(23.875 74.294)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_304",
    "data-name": "Ellipse 304",
    cx: 0.293,
    cy: 2.967,
    rx: 0.293,
    ry: 2.967,
    transform: "translate(528.178 373.59)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M501.935,302.209c0,.158-5.426.293-12.127.293s-12.138-.135-12.138-.293a120.905,120.905,0,0,1,12.138-.3,120.555,120.555,0,0,1,12.127.3Z",
    transform: "translate(20.332 74.607)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 12.668,
    height: 47.436,
    transform: "translate(485.536 414.652) rotate(-90)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M514.647,333.46a1.129,1.129,0,0,1-.26.147c-.169.09-.44.214-.79.361a13.541,13.541,0,0,1-3.215.925,8.326,8.326,0,0,1-5.212-.745,6.893,6.893,0,0,1-2.482-2.256,5.234,5.234,0,0,1-.869-3.655,3.813,3.813,0,0,1,.88-1.884,2.448,2.448,0,0,1,2-.9,2.854,2.854,0,0,1,2.008,1.128,3.915,3.915,0,0,1,.925,2.155,5.787,5.787,0,0,1-1.636,4.512,7.265,7.265,0,0,1-4.512,2.256,12.218,12.218,0,0,1-5.3-.654,9.8,9.8,0,0,1-4.659-3.136,5.065,5.065,0,0,1-1.128-2.73,3.553,3.553,0,0,1,1.015-2.854,2.256,2.256,0,0,1,1.478-.643,2.662,2.662,0,0,1,1.557.429,4.106,4.106,0,0,1,1.737,2.561,5.967,5.967,0,0,1-1.861,5.584,9.363,9.363,0,0,1-5.347,2.177,13.277,13.277,0,0,1-5.539-.553,7.648,7.648,0,0,1-4.208-3.271,5.64,5.64,0,0,1-.53-5.031,2.64,2.64,0,0,1,1.94-1.636,3,3,0,0,1,2.392.575,3.971,3.971,0,0,1,1.128,4.264,7.412,7.412,0,0,1-2.392,3.384,10.874,10.874,0,0,1-6.509,2.527,10.446,10.446,0,0,1-5.144-1.128,10.155,10.155,0,0,1-2.7-2,6.494,6.494,0,0,1-.564-.654c-.124-.158-.181-.237-.169-.248a12.069,12.069,0,0,0,3.531,2.7,10.322,10.322,0,0,0,5.031,1.038,10.446,10.446,0,0,0,6.25-2.516,6.95,6.95,0,0,0,2.256-3.17,3.486,3.486,0,0,0-.993-3.745,2.538,2.538,0,0,0-1.985-.474,2.12,2.12,0,0,0-1.557,1.342,5.088,5.088,0,0,0,.519,4.512,7.062,7.062,0,0,0,3.926,3.012,12.408,12.408,0,0,0,5.291.508,8.7,8.7,0,0,0,5-2.031,5.381,5.381,0,0,0,1.692-5.009,3.531,3.531,0,0,0-1.478-2.188,1.816,1.816,0,0,0-2.312.147,2.933,2.933,0,0,0-.835,2.369,4.512,4.512,0,0,0,.959,2.425,9.227,9.227,0,0,0,4.343,2.922,11.631,11.631,0,0,0,5.043.643,6.689,6.689,0,0,0,4.242-2.03,5.3,5.3,0,0,0,1.523-4.084,3.035,3.035,0,0,0-2.459-2.843,2.064,2.064,0,0,0-1.647.745,3.519,3.519,0,0,0-.79,1.67,4.839,4.839,0,0,0,.767,3.384,6.587,6.587,0,0,0,2.324,2.155,8.155,8.155,0,0,0,5.02.8,14.957,14.957,0,0,0,3.2-.8A7.146,7.146,0,0,1,514.647,333.46Z",
    transform: "translate(18.924 77.628)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 21.986,
    height: 43.194,
    transform: "translate(489.767 401.961) rotate(-90)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M476.767,305.64a92.827,92.827,0,0,1,.3,10.638,92.855,92.855,0,0,1-.3,10.638,97.882,97.882,0,0,1-.293-10.638,97.882,97.882,0,0,1,.293-10.638Z",
    transform: "translate(20.174 75.09)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M479.679,305.39a95.518,95.518,0,0,1,.293,10.5,95.646,95.646,0,0,1-.293,10.514,90.677,90.677,0,0,1-.3-10.514,90.571,90.571,0,0,1,.3-10.5Z",
    transform: "translate(20.545 75.059)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M504.367,304.77a100.343,100.343,0,0,1,.3,11.055,100.4,100.4,0,0,1-.3,11.067,105.914,105.914,0,0,1-.293-11.067,105.763,105.763,0,0,1,.293-11.055Z",
    transform: "translate(23.709 74.979)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M500.958,305a95.3,95.3,0,0,1,.3,10.773,95.423,95.423,0,0,1-.3,10.785,97.24,97.24,0,0,1-.293-10.784A97.105,97.105,0,0,1,500.958,305Z",
    transform: "translate(23.272 75.009)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 291.205,
    height: 193.163,
    transform: "translate(232.585 40.236)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M36.221,101.288A49.523,49.523,0,0,1,84.729,50.93l.417,25.856a23.693,23.693,0,1,0,.756,47.38l.417,25.867a49.512,49.512,0,0,1-50.1-48.745Z",
    transform: "translate(-36.213 -46.94)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M75.32,47.4c31.835-.519,57.217,24.186,57.724,56.156l-30.12.485c-.237-15.286-11.867-24.908-27.074-24.66Z",
    transform: "translate(-31.204 -47.393)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M245.758,451.078c-1.263-1.128-4.095-4.512-1.906-8.54.79-1.467,2.493-2.189,4.027-2.843a16.212,16.212,0,0,0,4.433-2.256c2.392-2.042,3.057-5.437,4.648-8.156,1.828-3.125,5.246-5.471,8.844-5.3,4.129.192,7.569,3.554,9.138,7.4s1.613,8.122,1.647,12.274c0,2.256-.09,4.885-1.771,6.43s-3.892,1.444-6,1.388l-22.562-.7",
    transform: "translate(-9.721 90.247)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M290.447,393H231.11l10.683,63.737a7.119,7.119,0,0,0,5.065,5.64l.214.056a3.331,3.331,0,0,1,.53.135,8.211,8.211,0,0,0,1.207.147v.056h26.747a7.554,7.554,0,0,0,1.444-.147,7.141,7.141,0,0,0,6-6.227l5.155-43.916.237-1.749h0l2.042-17.384Zm-11.2,40.611h-6.08l.609-18.489h7.051Zm2.177-18.489h5.832l-2.121,18.489H279.9Zm-17.4,39-.327-16.064h8.765l-.53,16.075Zm-9.487-16.075h8.528l.372,16.075H255.8Zm.666,16.075h-7.141c-.688-4.343-1.568-9.984-2.527-16.075h8.416Zm-1-20.509-1.444-18.489h9.814L263,433.611Zm9.352,0-.429-18.489h10.063l-.62,18.489Zm-.53-22.934-.395-17.124H273.91l-.564,17.124Zm-.587,0H252.42l-1.331-17.124h10.954Zm-10.6,0h-10.6c-.372-2.358-.733-4.6-1.049-6.611-1.128-6.926-1.523-9.532-1.76-10.514H250.5Zm.338,4.445,1.444,18.489H244.85c-.3-1.873-.6-3.768-.9-5.64-.677-4.366-1.365-8.731-2.019-12.815Zm-7.9,18.489h-5.731l-3.1-18.489h5.911c.914,5.719,1.884,12.082,2.9,18.489Zm.688,4.433c.88,5.561,1.737,11.044,2.527,16.075h-5.505l-2.7-16.075ZM272.5,454.12l.541-16.075H278.9L277.52,454.12Zm1.444-43.443.575-17.124H282.7l-1.466,17.124Zm-36.1-17.124c.237,1.241,1.32,7.976,2.764,17.124h-5.956l-2.865-17.124Zm44.808,60.567h-4.58l1.421-16.064h5.1Zm5.1-43.443h-6l1.467-17.124h6.52Z",
    transform: "translate(-11.25 86.28)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 124.597,
    height: 35.095,
    rx: 3.23,
    transform: "translate(145.734 293.684)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_305",
    "data-name": "Ellipse 305",
    cx: 7.592,
    cy: 7.626,
    rx: 7.592,
    ry: 7.626,
    transform: "translate(158.481 304.694)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M188.178,289.56a31.407,31.407,0,0,1-4.084,4.411c-.338.338-.677.654-1,.97l-.2.2-.192-.2a21.208,21.208,0,0,1-3.046-3.463,21.919,21.919,0,0,1,3.452,3.057H182.7l.993-.981a31.168,31.168,0,0,1,4.49-3.993Z",
    transform: "translate(-17.841 20.165)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M273.482,288.553c0,.158-16.73.293-37.351.293s-37.351-.135-37.351-.293,16.718-.293,37.351-.293S273.482,288.384,273.482,288.553Z",
    transform: "translate(-15.391 19.999)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M273.752,294.183c0,.169-16.73.293-37.351.293s-37.351-.124-37.351-.293,16.718-.293,37.351-.293S273.752,294.014,273.752,294.183Z",
    transform: "translate(-15.356 20.72)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M614.329,298.25,612.05,475.36h101.9v-174.7Z",
    transform: "translate(-30.141 74.144)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M662.843,299.43l-.9,175.779h45.62v-174.7Z",
    transform: "translate(-23.751 74.295)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M616.91,301.08V337.3h48.271V302.795Z",
    transform: "translate(-29.519 74.506)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M631.66,309.965v5.358h14.767V309.48Z",
    transform: "translate(-27.629 75.582)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 15.252,
    height: 2.188,
    transform: "translate(604.031 395.396)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M616.91,413.61v36.223h48.271V415.325Z",
    transform: "translate(-29.519 88.92)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M631.66,422.5v5.358h14.767V422.01Z",
    transform: "translate(-27.629 89.996)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 15.252,
    height: 2.188,
    transform: "translate(604.031 522.339)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M616.91,337.28V373.5h48.271V338.995Z",
    transform: "translate(-29.519 79.143)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M631.66,346.165v5.358h14.767V345.68Z",
    transform: "translate(-27.629 80.219)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 15.252,
    height: 2.188,
    transform: "translate(604.031 436.232)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 48.271,
    height: 36.223,
    transform: "translate(586.76 459.798)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M631.39,390.251v5.031h13.887V389.8Z",
    transform: "translate(-27.664 85.87)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 14.338,
    height: 2.053,
    transform: "translate(603.726 485.383)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor",
    transform: "translate(45.246 469.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M774.062,453.923c0,.169-163.4.293-364.9.293s-364.943-.124-364.943-.293,163.364-.293,364.943-.293S774.062,453.765,774.062,453.923Z",
    transform: "translate(-44.22 -453.63)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-2",
    transform: "translate(87.075 -33.569)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 301.572,
    height: 197.81,
    transform: "translate(164.272 0.35)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M528.517,285.2c0-1.906-.09-77.161-.237-197.81l.237.237H226.968l.293-.293v197.81l-.271-.271,301.572.271-301.572.271h-.271V87.04h.316l301.549.068h.237v.226C528.608,208.039,528.517,283.282,528.517,285.2Z",
    transform: "translate(-62.674 -87.04)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M308.641,184.18l29.657.417c-.226,15.793-13.537,28.687-29.657,28.687h-.181Z",
    transform: "translate(-52.204 -74.598)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M356.5,222.34a3.632,3.632,0,0,1-.643,0h-1.8l-6.633.079h-.056l-.056-.068c-2.651-3.328-6.058-7.637-9.781-12.33l-7.9-10.051.158.068-8.731-.079-2.459.056a4.061,4.061,0,0,1-.869,0,5.287,5.287,0,0,1,.869-.056h2.437l8.731-.079h.09v.068l7.9,10.029,9.7,12.409-.135-.068,6.633.079h1.8A2.935,2.935,0,0,1,356.5,222.34Z",
    transform: "translate(-51.016 -72.587)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M363.71,222.846c0,.124-4.3.226-9.6.226s-9.6-.1-9.6-.226,4.3-.226,9.6-.226S363.71,222.722,363.71,222.846Z",
    transform: "translate(-47.586 -69.674)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M363.71,226.026c0,.124-4.3.226-9.6.226s-9.6-.1-9.6-.226,4.3-.226,9.6-.226A90.275,90.275,0,0,1,363.71,226.026Z",
    transform: "translate(-47.586 -69.267)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M307.829,183.743l-.417,29.1c-16.109-.226-29.251-13.289-29.251-29.1s13.39-29.093,29.669-29.093S337.5,167.781,337.5,183.743Z",
    transform: "translate(-56.085 -78.38)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M297.231,174.062a2.125,2.125,0,0,1-.508.113l-1.478.237-5.325.756h-.09l-.068-.068-7.107-6.915c-3.384-3.384-6.487-6.4-8.7-8.619l-2.595-2.651a7.734,7.734,0,0,1-.914-1.015,7.238,7.238,0,0,1,1.038.891l2.7,2.538c2.256,2.166,5.37,5.178,8.788,8.528l7.051,6.972h-.158l5.358-.587,1.478-.135a1.456,1.456,0,0,1,.53-.045Z",
    transform: "translate(-57.072 -78.22)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M265.969,154.806c0,.124-4.3.226-9.6.226s-9.589-.1-9.589-.226,4.287-.226,9.589-.226S265.969,154.682,265.969,154.806Z",
    transform: "translate(-60.104 -78.389)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M265.969,157.956c0,.124-4.3.226-9.6.226s-9.589-.1-9.589-.226,4.287-.226,9.589-.226S265.969,157.832,265.969,157.956Z",
    transform: "translate(-60.104 -77.985)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M398.991,131.529l-.113-18.049a23.126,23.126,0,0,0-14.925,5.821,21.434,21.434,0,0,0-7.186,18.726,24.946,24.946,0,0,0,.429,2.628.147.147,0,0,0,0,.068h0l21.783-4.907Z",
    transform: "translate(-43.474 -83.653)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(333.138 29.827)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M398.991,131.529l-.113-18.049a23.126,23.126,0,0,0-14.925,5.821,21.434,21.434,0,0,0-7.186,18.726,24.946,24.946,0,0,0,.429,2.628.147.147,0,0,0,0,.068h0l21.783-4.907Z",
    transform: "translate(-376.612 -113.48)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M418.648,125.955a21.434,21.434,0,0,0-17.587-12.307l-.688-.068H398.5l.124,18.049v4.242L420.5,140.6h0a20.947,20.947,0,0,0,.485-4.682,23.363,23.363,0,0,0-2.335-9.961Z",
    transform: "translate(-40.671 -83.641)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(357.829 29.939)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M418.648,125.955a21.434,21.434,0,0,0-17.587-12.307l-.688-.068H398.5l.124,18.049v4.242L420.5,140.6h0a20.947,20.947,0,0,0,.485-4.682,23.363,23.363,0,0,0-2.335-9.961Z",
    transform: "translate(-398.5 -113.58)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M399.965,135.25l-21.795,4.907a22.336,22.336,0,0,0,43.612-.147l-21.795-4.761",
    transform: "translate(-43.275 -80.865)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M478.384,132.4c0,.158-11.281.293-25.156.293s-25.168-.135-25.168-.293,11.281-.3,25.168-.3S478.384,132.235,478.384,132.4Z",
    transform: "translate(-36.884 -81.268)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M478.384,127.313c0,.158-11.281.293-25.156.293s-25.168-.135-25.168-.293,11.281-.293,25.168-.293S478.384,127.155,478.384,127.313Z",
    transform: "translate(-36.884 -81.919)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M478.384,122.233c0,.158-11.281.293-25.156.293s-25.168-.135-25.168-.293,11.281-.293,25.168-.293S478.384,122.064,478.384,122.233Z",
    transform: "translate(-36.884 -82.57)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M478.384,137.135c0,.158-11.281.293-25.156.293s-25.168-.135-25.168-.293,11.281-.3,25.168-.3S478.384,137.022,478.384,137.135Z",
    transform: "translate(-36.884 -80.663)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M462.785,142.273c0,.169-7.739.293-17.282.293s-17.282-.124-17.282-.293,7.739-.293,17.282-.293S462.785,142.115,462.785,142.273Z",
    transform: "translate(-36.864 -80.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 5.178,
    height: 57.882,
    transform: "translate(338.415 103.795)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 5.178,
    height: 38.22,
    transform: "translate(348.421 123.447)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 5.178,
    height: 50.978,
    transform: "translate(358.427 110.981)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 5.178,
    height: 55.649,
    transform: "translate(368.434 106.029)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 5.178,
    height: 37.046,
    transform: "translate(378.428 124.62)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 5.178,
    height: 29.782,
    transform: "translate(388.435 131.885)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 5.178,
    height: 51.937,
    transform: "translate(398.441 109.729)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 5.178,
    height: 42.574,
    transform: "translate(408.447 119.092)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 5.178,
    height: 50.053,
    transform: "translate(418.453 111.613)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 5.178,
    height: 34.102,
    transform: "translate(428.459 127.564)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 5.178,
    height: 40.589,
    transform: "translate(438.465 121.078)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M488.918,233.954c0,.113-24.581.214-54.9.214s-54.9-.1-54.9-.214,24.581-.214,54.9-.214S488.918,233.83,488.918,233.954Z",
    transform: "translate(-43.154 -68.25)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M388.714,238.024a36.536,36.536,0,0,1-7.694,0,34.633,34.633,0,0,1,7.694,0Z",
    transform: "translate(-42.91 -67.728)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M400.194,238.194a49.4,49.4,0,0,1-9.194,0,49.4,49.4,0,0,1,9.194,0Z",
    transform: "translate(-41.631 -67.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M409.844,238.194a49.4,49.4,0,0,1-9.194,0A49.4,49.4,0,0,1,409.844,238.194Z",
    transform: "translate(-40.395 -67.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M419.484,238.194a49.4,49.4,0,0,1-9.194,0,49.4,49.4,0,0,1,9.194,0Z",
    transform: "translate(-39.16 -67.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M429.134,238.194a49.4,49.4,0,0,1-9.194,0A49.4,49.4,0,0,1,429.134,238.194Z",
    transform: "translate(-37.924 -67.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M438.774,238.194a49.4,49.4,0,0,1-9.194,0,49.4,49.4,0,0,1,9.194,0Z",
    transform: "translate(-36.69 -67.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M448.424,238.194a49.4,49.4,0,0,1-9.194,0A49.4,49.4,0,0,1,448.424,238.194Z",
    transform: "translate(-35.454 -67.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M458.044,238.194a49.4,49.4,0,0,1-9.194,0A49.4,49.4,0,0,1,458.044,238.194Z",
    transform: "translate(-34.221 -67.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M467.714,238.194a49.4,49.4,0,0,1-9.194,0A49.4,49.4,0,0,1,467.714,238.194Z",
    transform: "translate(-32.983 -67.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M477.364,238.194a49.4,49.4,0,0,1-9.194,0A49.4,49.4,0,0,1,477.364,238.194Z",
    transform: "translate(-31.747 -67.706)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(348.421 123.447)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 5.178,
    height: 38.22,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(368.434 106.029)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 5.178,
    height: 55.649,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(388.435 131.885)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 5.178,
    height: 29.782,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(408.447 119.092)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 5.178,
    height: 42.574,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(428.459 127.564)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 5.178,
    height: 34.102,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M260.535,120.876a5,5,0,1,1-4.986-4.986A5,5,0,0,1,260.535,120.876Z",
    transform: "translate(-59.622 -83.345)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M343.961,116.853c0,.169-16.82.293-37.565.293s-37.565-.124-37.565-.293,16.809-.293,37.565-.293S343.961,116.7,343.961,116.853Z",
    transform: "translate(-57.28 -83.259)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M298.915,122.2a4.162,4.162,0,0,1-1.128.113l-3.17.1c-2.685,0-6.385.079-10.469.079s-7.8,0-10.469-.079l-3.181-.1a4.253,4.253,0,0,1-1.128-.113,4.907,4.907,0,0,1,1.128-.113c.756,0,1.839-.068,3.181-.09,2.674,0,6.374-.09,10.469-.09s7.784,0,10.469.09c1.342,0,2.425.056,3.17.09a4.8,4.8,0,0,1,1.128.113Z",
    transform: "translate(-57.211 -82.574)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    "data-name": "Path 3199",
    d: "M0,0H157.831V180.133H0V0Z",
    transform: "translate(0.293 18.264)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M239.435,283.381V270.307c0-8.506,0-20.949-.068-36.753,0-31.586-.079-76.586-.124-130.294l.259.259H81.684l.293-.293V283.347l-.248-.248,114.3.169,32.015.068h.1l-31.959.068-114.636.124H81.3V103H239.695v.259c-.056,53.776-.1,98.832-.135,130.463,0,15.793-.056,28.2-.068,36.685v12.15A4.361,4.361,0,0,1,239.435,283.381Z",
    transform: "translate(-81.3 -84.996)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 109.661,
    height: 45.541,
    transform: "translate(26.059 44.526)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 133.319,
    height: 74.801,
    transform: "translate(14.23 103.363)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M125.763,139.84a5.122,5.122,0,1,1-5.122-5.11,5.122,5.122,0,0,1,5.122,5.11Z",
    transform: "translate(-76.917 -80.932)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 35.625,
    height: 1.974,
    transform: "translate(53.956 55.378)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 69.298,
    height: 1.974,
    transform: "translate(53.956 59.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M125.763,153.78a5.11,5.11,0,1,1-1.5-3.617A5.121,5.121,0,0,1,125.763,153.78Z",
    transform: "translate(-76.917 -79.146)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    width: 18.185,
    height: 1.974,
    transform: "translate(53.956 71.103)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 69.298,
    height: 1.974,
    transform: "translate(53.956 75.593)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2",
    transform: "translate(304.187 213.888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 67.223,
    height: 3.271,
    transform: "translate(79.609 119.999)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M336.521,341.784l-12.6-47.244H376.4l11.416,47.244Z",
    transform: "translate(-267.335 -218.514)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M384.332,337.961H337.449L326.54,296.47h47.12Z",
    transform: "translate(-267 -218.267)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M327.318,299.459h47.12l-.8-2.989h-47.1Z",
    transform: "translate(-267 -218.267)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M331.74,297.859a.519.519,0,1,0,.519-.519A.519.519,0,0,0,331.74,297.859Z",
    transform: "translate(-266.333 -218.156)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M330.17,297.859a.519.519,0,1,0,.519-.519A.519.519,0,0,0,330.17,297.859Z",
    transform: "translate(-266.535 -218.156)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M328.6,297.859a.482.482,0,1,0,.519-.519A.519.519,0,0,0,328.6,297.859Z",
    transform: "translate(-266.736 -218.156)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M359.578,316.084,364.744,322a7.3,7.3,0,0,0,3.147-5.945c0-4.129-3.79-7.513-8.359-7.491s-8.325,3.384-8.3,7.558Z",
    transform: "translate(-263.837 -216.719)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M359,316.08a11.548,11.548,0,0,1,1.478,1.478c.925.993,2.256,2.437,3.813,4.2l.181.2-.226.158a8.878,8.878,0,0,1-8.7.857,8.574,8.574,0,0,1-3.587-2.877,7.344,7.344,0,0,1-1.32-3.881V316h6.193a13.478,13.478,0,0,1,2.177.1,15.386,15.386,0,0,1-2.256.181c-1.421.068-3.384.135-5.843.2l.248-.271a7.084,7.084,0,0,0,1.286,3.576,8,8,0,0,0,3.384,2.662,8.551,8.551,0,0,0,8.179-.711v.361c-1.5-1.748-2.73-3.226-3.587-4.275A14.982,14.982,0,0,1,359,316.08Z",
    transform: "translate(-263.913 -215.766)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M355.06,311.333a.485.485,0,0,0,.474.474.474.474,0,0,0,.463-.474.468.468,0,0,0-.936,0Z",
    transform: "translate(-263.347 -216.423)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M346.83,308.33a26.213,26.213,0,0,1,5.584-.316h.857l.09.079a22.323,22.323,0,0,1,3.226,3.61,22.753,22.753,0,0,1-3.644-3.192l.214.079h-.745a27.3,27.3,0,0,1-5.584-.26Z",
    transform: "translate(-264.401 -216.793)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M337.693,314.5a14.6,14.6,0,0,1-.541-2.177c-.316-1.433-.756-3.52-1.275-6.08l-.056-.282h.293l11.664-.1c-.068,0,.553.463.293.248h0v.541l.1.553c.068.372.147.733.214,1.128.135.722.259,1.433.395,2.132.259,1.388.5,2.719.733,3.982l.056.316h-.316c-3.508,0-6.453-.056-8.506-.09l-2.358-.068a3.3,3.3,0,0,1-.8-.068,5.083,5.083,0,0,1,.9-.068l2.414-.079c2.064-.056,4.941-.124,8.348-.158l-.259.316-.677-4.016c-.135-.688-.271-1.4-.406-2.121-.068-.361-.147-.733-.214-1.128l-.1-.553-.056-.282V306.2h0c-.259-.214.35.293.282.248h-11.71l.237-.282c.44,2.47.778,4.512,1.015,6S337.715,314.467,337.693,314.5Z",
    transform: "translate(-265.811 -217.064)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M354.45,319.664a.468.468,0,1,0,.462-.474.463.463,0,0,0-.462.474Z",
    transform: "translate(-263.425 -215.357)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M347.35,319.681a15.208,15.208,0,0,1,4.242-.316,14.95,14.95,0,0,1,4.23.282,15.418,15.418,0,0,1-4.23.3,15.789,15.789,0,0,1-4.242-.271Z",
    transform: "translate(-264.334 -215.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M337.72,323.633a10.377,10.377,0,0,1-.508-1.557c-.3-1.038-.745-2.572-1.275-4.512l-.068-.271h.282c3.181-.056,7.412-.1,12.037-.113l.282.214h0v.395l.1.406.2.79c.135.53.271,1.049.395,1.557.259,1.015.508,2.008.745,2.956l.09.338h-.35c-3.565,0-6.611,0-8.731-.09l-2.459-.068a3.9,3.9,0,0,1-.846-.068,6.573,6.573,0,0,1,.948-.079l2.516-.079c2.132-.068,5.1-.124,8.574-.158l-.271.338c-.248-.948-.508-1.929-.767-2.944l-.406-1.557-.2-.8-.1-.395-.056-.2v-.181h0c-.068,0,.542.417.282.226H336.107l.2-.282c.451,1.85.79,3.384,1.027,4.433a11.224,11.224,0,0,1,.383,1.7Z",
    transform: "translate(-265.804 -215.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M338.3,308.449a14.169,14.169,0,0,1,3.982-.3,13.311,13.311,0,0,1,3.993.282,14.223,14.223,0,0,1-3.993.3A13.268,13.268,0,0,1,338.3,308.449Z",
    transform: "translate(-265.493 -216.777)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M338.38,309.609a14.455,14.455,0,0,1,4.016-.3,14.179,14.179,0,0,1,4.016.271,27.072,27.072,0,0,1-8.032,0Z",
    transform: "translate(-265.483 -216.628)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M338.59,310.73a12.793,12.793,0,0,1,3.881-.316,13.46,13.46,0,0,1,3.869.282,12.68,12.68,0,0,1-3.869.316A13.534,13.534,0,0,1,338.59,310.73Z",
    transform: "translate(-265.456 -216.486)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M338.51,319.579a12.83,12.83,0,0,1,3.8-.3,12.115,12.115,0,0,1,3.8.282,12.95,12.95,0,0,1-3.8.3,12.117,12.117,0,0,1-3.8-.282Z",
    transform: "translate(-265.466 -215.352)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M338.92,320.853a18.142,18.142,0,0,1,6.5,0A18.139,18.139,0,0,1,338.92,320.853Z",
    transform: "translate(-265.414 -215.182)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M273.76,336.29v6.193h4.061V467.938h8.325V342.483h44.187V467.938h8.325V342.483h191.7V467.9h8.336V342.483h3.6V336.29Z",
    transform: "translate(-273.76 -213.167)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M433.8,377.746a62.056,62.056,0,0,0,10.83,0,65.08,65.08,0,0,0-10.83,0Z",
    transform: "translate(-253.261 -207.886)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_307",
    "data-name": "Ellipse 307",
    cx: 0.293,
    cy: 0.147,
    rx: 0.293,
    ry: 0.147,
    transform: "translate(101.381 170.853)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M416.283,285.305l-31.09-31.586-.677-3.384c-.124-.62-.259-1.32-.384-2.121a8.482,8.482,0,0,1,.056-2.775,12.407,12.407,0,0,1,.959-3.317c.519-.914-.316-2.019-1.184-1.636s-2.369,2.854-2.7,6.272-3.238-1.128-4.321-2.753-4.693-6.509-5.449-6.566c-1.128-.09-1.376,1.128-.259,2.707s4.174,6.656,3.317,7.186h0a4.061,4.061,0,0,0-4.3,2.132c-.79,1.5-1.658,3.644-.948,4.625a56.061,56.061,0,0,0,4.964,5.257l1.038.891s26.9,38.987,32.771,40.261c3.644.778,60.025,5.46,60.025,5.46l4.253-15.534Z",
    transform: "translate(-261.555 -225.829)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M369,251.826l2.877,2.764a3.553,3.553,0,0,0,1.128.8,1.2,1.2,0,0,0,1.263-.2,1.218,1.218,0,0,0,.169-1.128,3.386,3.386,0,0,0-.666-1.015l-2.8-3.384",
    transform: "translate(-261.561 -224.263)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M370.97,249.65c.068-.056.6.474,1.421,1.388.463.519.936,1.049,1.421,1.613a5.2,5.2,0,0,1,.8,1.072,1.534,1.534,0,0,1-.079,1.591,1.41,1.41,0,0,1-1.579.361,3.191,3.191,0,0,1-1.128-.79l-1.5-1.534c-.846-.88-1.342-1.455-1.286-1.523a6.836,6.836,0,0,1,1.568,1.23l1.591,1.433a2.718,2.718,0,0,0,.948.643.869.869,0,0,0,.925-.181.981.981,0,0,0,0-.981,5.531,5.531,0,0,0-.688-.981c-.462-.575-.9-1.128-1.331-1.692a6.544,6.544,0,0,1-1.083-1.647Z",
    transform: "translate(-261.556 -224.265)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M370.85,250.048l2.877,2.764a3.386,3.386,0,0,0,1.128.79,1.128,1.128,0,0,0,1.263-.2,1.2,1.2,0,0,0,.169-1.128,3.563,3.563,0,0,0-.666-1.027l-2.8-3.384",
    transform: "translate(-261.324 -224.493)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M372.778,247.86a8.824,8.824,0,0,1,1.421,1.4l1.421,1.6a5.2,5.2,0,0,1,.8,1.072,1.556,1.556,0,0,1-.079,1.6,1.41,1.41,0,0,1-1.579.361,3.193,3.193,0,0,1-1.128-.79l-1.489-1.534a6.97,6.97,0,0,1-1.286-1.523,6.949,6.949,0,0,1,1.568,1.218l1.591,1.444a2.719,2.719,0,0,0,.948.643.868.868,0,0,0,.925-.18,1,1,0,0,0,0-.993,5.008,5.008,0,0,0-.7-.97l-1.32-1.692A6.263,6.263,0,0,1,372.778,247.86Z",
    transform: "translate(-261.323 -224.493)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M372.84,248.591l2.877,2.764a3.125,3.125,0,0,0,1.128.79,1.027,1.027,0,0,0,1.421-1.354,3.383,3.383,0,0,0-.666-1.027c-.925-1.128-1.861-2.256-2.786-3.384",
    transform: "translate(-261.069 -224.683)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M374.765,246.4a7.357,7.357,0,0,1,1.421,1.388l1.421,1.613a5.178,5.178,0,0,1,.79,1.072,1.5,1.5,0,0,1-.079,1.6,1.388,1.388,0,0,1-1.568.361,3.192,3.192,0,0,1-1.128-.79l-1.478-1.534a6.678,6.678,0,0,1-1.275-1.523,6.769,6.769,0,0,1,1.568,1.218l1.591,1.444a2.786,2.786,0,0,0,.936.643.857.857,0,0,0,.925-.18.948.948,0,0,0,0-.993,5.465,5.465,0,0,0-.688-.97l-1.32-1.692A6.262,6.262,0,0,1,374.765,246.4Z",
    transform: "translate(-261.065 -224.68)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M376.87,253.113c0-.1.711-.237,1.749.079l-.327.282a4.918,4.918,0,0,1-.079-1.974,5.02,5.02,0,0,1,1.128-2.4c.44-.519.812-.722.857-.666a10.211,10.211,0,0,0-1.354,3.159,5.947,5.947,0,0,0,0,1.782l.056.451-.384-.169C377.547,253.271,376.859,253.225,376.87,253.113Z",
    transform: "translate(-260.553 -224.422)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M450.2,238.485l.135,43.285-16.921.8-.677-10.367s-8.145,1.23-9.848-4.9c-1.128-3.914-.812-34.147-.812-34.147Z",
    transform: "translate(-254.768 -226.376)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M418.5,238.194c1.252,2.595,7.209,7.321,7.209,7.321l2.7,7.209c2.335-1.828,5.471-1.726,6.069,2.38.429,2.978-3.26,3.576-3.26,3.576,2.143,3.655,3.6,6.611,6.769,10.085,3.384,3.768,5.279,4.14,8.957,4.208h4.05s8.28-6.926,6.644-25.156-18.072-12.939-21.987-17.452C429.309,222.931,414.328,229.565,418.5,238.194Z",
    transform: "translate(-255.313 -227.147)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M456.565,262.291a5.764,5.764,0,0,1-2-.09,10.378,10.378,0,0,1-4.839-2.482,26.375,26.375,0,0,1-4.885-6.464c-1.579-2.583-3.305-5.584-6.2-7.592s-6.385-2.358-9.352-2.967a17.711,17.711,0,0,1-7.547-2.877,8.088,8.088,0,0,1-3.023-4.512,4.513,4.513,0,0,1-.079-2,6.226,6.226,0,0,0,.169,1.974,8.077,8.077,0,0,0,3.035,4.377,17.745,17.745,0,0,0,7.491,2.786c2.956.6,6.43.981,9.442,2.989s4.682,5.088,6.25,7.671a26.76,26.76,0,0,0,4.817,6.453,10.525,10.525,0,0,0,4.738,2.516,8.145,8.145,0,0,0,1.466.18Z",
    transform: "translate(-255.213 -226.357)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M457.5,247.719l-.869-.271a14.589,14.589,0,0,0-2.549-.564,5.64,5.64,0,0,0-3.9.88,3.2,3.2,0,0,0-1.365,2.053,2.865,2.865,0,0,0,.79,2.583,2.256,2.256,0,0,0,1.365.541,2.775,2.775,0,0,0,1.5-.417,4.591,4.591,0,0,0,2.042-2.606,6.441,6.441,0,0,0-5.449-8.461,11.416,11.416,0,0,0-4.185.541,29.756,29.756,0,0,1-4.343,1.049,17.463,17.463,0,0,1-4.6,0,15.3,15.3,0,0,1-4.445-1.23,5.347,5.347,0,0,1-3.035-3.2,4.208,4.208,0,0,1,1.026-4.095,3.61,3.61,0,0,1,3.971-.575,3,3,0,0,1,1.467,1.376,3.385,3.385,0,0,1,.316,1.94,4.434,4.434,0,0,1-1.974,3.091,6.375,6.375,0,0,1-3.384.936,9.9,9.9,0,0,1-3.159-.485,11.418,11.418,0,0,1-4.648-2.865,11.766,11.766,0,0,1-2.369-3.384,12.331,12.331,0,0,1-.846-2.482c-.1-.587-.135-.9-.135-.9s.068.3.18.891a13.017,13.017,0,0,0,.88,2.448,11.576,11.576,0,0,0,2.38,3.384,11.134,11.134,0,0,0,4.6,2.8,9.634,9.634,0,0,0,3.114.474,6.215,6.215,0,0,0,3.226-.914,4.208,4.208,0,0,0,1.873-2.956,2.9,2.9,0,0,0-1.658-3.1,3.384,3.384,0,0,0-3.723.553,3.971,3.971,0,0,0-.97,3.858,5.166,5.166,0,0,0,2.922,3.057,14.754,14.754,0,0,0,4.411,1.162,17.034,17.034,0,0,0,4.512,0,28.882,28.882,0,0,0,4.309-1.027,11.4,11.4,0,0,1,4.287-.553A6.667,6.667,0,0,1,454.706,250a4.817,4.817,0,0,1-2.143,2.7,2.956,2.956,0,0,1-1.591.429,2.335,2.335,0,0,1-1.478-.587,3.046,3.046,0,0,1-.823-2.73,3.385,3.385,0,0,1,1.433-2.143,5.821,5.821,0,0,1,3.994-.857,12.613,12.613,0,0,1,2.549.609C457.21,247.595,457.5,247.719,457.5,247.719Z",
    transform: "translate(-255.192 -226.631)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M434.827,445.605l-5.505-7.073L442.51,428.12l8.179,10.266-.778.7c-3.475,3.068-17.914,15.4-20.926,16.583C425.622,456.988,434.827,445.605,434.827,445.605Z",
    transform: "translate(-253.972 -201.404)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(174.278 236.711)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M430.484,450.224s-3.035,4.242-2.031,4.512,16.053-11.642,22.235-17.474l-.259-.282-17.44,14.033S431.273,449.648,430.484,450.224Z",
    transform: "translate(-428.25 -436.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M450.629,436.82a1.3,1.3,0,0,1-.2.2l-.62.553-2.313,2c-1.974,1.67-4.715,3.948-7.806,6.4s-5.934,4.6-8.009,6.126l-2.482,1.8-.677.474-.248.147.226-.181.654-.508,2.437-1.85c2.053-1.557,4.885-3.723,7.976-6.171s5.843-4.7,7.829-6.351l2.358-1.94.643-.53Z",
    transform: "translate(-253.969 -200.29)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M432.928,449.723a6.891,6.891,0,0,0-1.354-.79,6.58,6.58,0,0,0-1.534-.271,2.714,2.714,0,0,1,2.888,1.06Z",
    transform: "translate(-253.742 -198.787)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M434.848,445.174c0,.056-.383,0-.823-.169s-.767-.316-.745-.372.384,0,.812.181a1.929,1.929,0,0,1,.756.361Z",
    transform: "translate(-253.328 -199.292)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M435.38,443.877c0,.056-.327.09-.711.068s-.7-.09-.7-.147.316-.09.711-.056A1.534,1.534,0,0,1,435.38,443.877Z",
    transform: "translate(-253.239 -199.405)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M435.1,442.291a3.618,3.618,0,0,1-.62.632c-.384.3-.711.519-.745.474s.248-.327.62-.632S435.061,442.246,435.1,442.291Z",
    transform: "translate(-253.27 -199.59)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M434.7,441.35a2.5,2.5,0,0,1-1.466,1.354,7.334,7.334,0,0,1,.745-.677C434.381,441.655,434.651,441.316,434.7,441.35Z",
    transform: "translate(-253.334 -199.71)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M433.819,444.442a2.922,2.922,0,0,1-.846.666,6.685,6.685,0,0,1-1.06.508,2.9,2.9,0,0,1-.688.2.654.654,0,0,1-.417-.1.417.417,0,0,1-.135-.44,1.974,1.974,0,0,1,2.256-1.06,1.875,1.875,0,0,1,.722.338c.147.124.214.2.2.214a2.844,2.844,0,0,0-.959-.417,1.9,1.9,0,0,0-1.128.1,1.692,1.692,0,0,0-.959.869.274.274,0,0,0,.35.293,4.383,4.383,0,0,0,.632-.169,9.853,9.853,0,0,0,1.06-.463C433.481,444.668,433.8,444.409,433.819,444.442Z",
    transform: "translate(-253.664 -199.35)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M433.395,444.867a1.217,1.217,0,0,1-.564-.508,1.814,1.814,0,0,1-.259-.812,1.128,1.128,0,0,1,.361-.981.429.429,0,0,1,.575.18,1.22,1.22,0,0,1,.158.5,3.383,3.383,0,0,1,0,.824,1.569,1.569,0,0,1-.214.733,5.563,5.563,0,0,1,.068-.745,3.266,3.266,0,0,0,0-.79c0-.271-.2-.654-.44-.519a.948.948,0,0,0-.271.8,1.75,1.75,0,0,0,.192.733,4.047,4.047,0,0,0,.395.587Z",
    transform: "translate(-253.42 -199.56)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M445.626,433.81a5.994,5.994,0,0,0-.936.8,5.3,5.3,0,0,0-1.286,5.482,12.1,12.1,0,0,0,.5,1.128c-.034,0-.09-.079-.214-.259a5.419,5.419,0,0,1-.417-.824,5.3,5.3,0,0,1-.214-3.023,5.1,5.1,0,0,1,1.534-2.617,4.41,4.41,0,0,1,.733-.553,1,1,0,0,1,.3-.135Z",
    transform: "translate(-252.092 -200.676)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M440.27,429.9a30.875,30.875,0,0,1,2.256,2.617,34.6,34.6,0,0,1,2.1,2.753,28.653,28.653,0,0,1-2.256-2.617,26.084,26.084,0,0,1-2.1-2.753Z",
    transform: "translate(-252.432 -201.176)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M441.883,440.5a9.027,9.027,0,0,1-1.771,1.715,9.629,9.629,0,0,1-2.042,1.365s.869-.677,1.918-1.534S441.849,440.455,441.883,440.5Z",
    transform: "translate(-252.714 -199.819)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M443.75,438.68c.056,0,.079.237.147.508s.158.485.113.519-.237-.158-.316-.474S443.7,438.669,443.75,438.68Z",
    transform: "translate(-251.998 -200.052)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M443.784,436.93c.056,0,.079.2,0,.451s-.09.44-.147.44-.079-.214-.056-.463S443.728,436.919,443.784,436.93Z",
    transform: "translate(-252.009 -200.276)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M444.667,435.462s-.147.192-.282.406-.2.44-.259.429-.09-.271.079-.542S444.656,435.406,444.667,435.462Z",
    transform: "translate(-251.944 -200.466)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M445.328,434.531v.282a.23.23,0,0,1-.226.192c-.045-.023,0-.158,0-.293A.209.209,0,0,1,445.328,434.531Z",
    transform: "translate(-251.816 -200.584)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(178.667 231.882)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M446.715,433.614l-13.345,10.2-1.23-1.613,14.022-9.5Z",
    transform: "translate(-432.14 -432.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M381.61,450.946v-8.968l16.808-.068.1,13.131-1.049.068c-4.636.282-23.588,1.072-26.691.147C367.34,454.217,381.61,450.946,381.61,450.946Z",
    transform: "translate(-261.401 -199.638)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(108.805 253.158)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M374.643,451.56s-5.009,1.455-4.377,2.256,19.82.745,28.281,0v-.372l-22.381.282S375.613,451.594,374.643,451.56Z",
    transform: "translate(-370.211 -451.56)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M398.779,453.215h-1.128l-3.046.147c-2.583.1-6.148.2-10.085.226s-7.513,0-10.1-.124l-3.046-.113h3.057c2.572,0,6.148.079,10.085.068s7.5-.1,10.074-.169l3.057-.079h1.128Z",
    transform: "translate(-261.401 -198.196)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M375.655,453.993a7.013,7.013,0,0,0-.587-1.455,6.5,6.5,0,0,0-1.038-1.128,2.726,2.726,0,0,1,1.625,2.583Z",
    transform: "translate(-260.917 -198.421)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M379.952,451.608a3.686,3.686,0,0,1-.53-.643c-.248-.384-.406-.722-.361-.745s.282.248.53.643S380,451.585,379.952,451.608Z",
    transform: "translate(-260.273 -198.574)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M381.181,450.917a2.621,2.621,0,0,1-.6-.395c-.293-.26-.5-.5-.463-.542s.3.135.6.395S381.215,450.872,381.181,450.917Z",
    transform: "translate(-260.137 -198.605)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M382.009,449.412a1.839,1.839,0,0,1-.869.113,1.9,1.9,0,0,1-.88-.09,2.019,2.019,0,0,1,.869-.113,2.1,2.1,0,0,1,.88.09Z",
    transform: "translate(-260.119 -198.69)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M382.3,448.41a1.772,1.772,0,0,1-.981.282,1.693,1.693,0,0,1-1-.124,5.231,5.231,0,0,1,.993-.079A5.724,5.724,0,0,1,382.3,448.41Z",
    transform: "translate(-260.112 -198.806)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M379.7,450.328a3.247,3.247,0,0,1-1.128,0,5.905,5.905,0,0,1-1.128-.248,3.024,3.024,0,0,1-.654-.259.632.632,0,0,1-.271-.338.417.417,0,0,1,.169-.429,1.974,1.974,0,0,1,2.448.564,1.883,1.883,0,0,1,.35.722.642.642,0,0,1,0,.293,3.021,3.021,0,0,0-.5-.925,2,2,0,0,0-.925-.6,1.647,1.647,0,0,0-1.286.1c-.169.124-.1.327.09.44a2.648,2.648,0,0,0,.609.248,6.767,6.767,0,0,0,1.128.293C379.319,450.295,379.7,450.295,379.7,450.328Z",
    transform: "translate(-260.599 -198.75)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M379.106,450.437a1.128,1.128,0,0,1-.124-.745,1.749,1.749,0,0,1,.293-.79,1.128,1.128,0,0,1,.891-.553.417.417,0,0,1,.338.5,1.242,1.242,0,0,1-.181.485,3.215,3.215,0,0,1-.508.654c-.338.327-.6.463-.62.44s.214-.192.519-.542a3.956,3.956,0,0,0,.451-.643c.147-.237.237-.643,0-.688s-.542.237-.7.451a1.736,1.736,0,0,0-.3.711,6.854,6.854,0,0,0-.056.722Z",
    transform: "translate(-260.285 -198.813)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M395.886,449.151h-1.241a5.505,5.505,0,0,0-2.7,1.128,5.336,5.336,0,0,0-1.681,2.4,11.625,11.625,0,0,0-.316,1.207.881.881,0,0,1,0-.338,3.982,3.982,0,0,1,.169-.914,5.358,5.358,0,0,1,1.692-2.516,5.155,5.155,0,0,1,2.82-1.128,3.889,3.889,0,0,1,.925,0A.813.813,0,0,1,395.886,449.151Z",
    transform: "translate(-258.879 -198.734)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M393.645,442.94a28.528,28.528,0,0,1,.169,3.452,31.723,31.723,0,0,1,0,3.452,27.314,27.314,0,0,1-.158-3.452,30.236,30.236,0,0,1-.011-3.452Z",
    transform: "translate(-258.41 -199.506)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M388.557,452a9.711,9.711,0,0,1-2.448.248,10.085,10.085,0,0,1-2.459-.181c0-.056,1.128,0,2.459,0S388.557,452,388.557,452Z",
    transform: "translate(-259.685 -198.346)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M391.055,452s-.079.237-.192.485-.181.474-.237.474-.079-.271,0-.553A.576.576,0,0,1,391.055,452Z",
    transform: "translate(-258.798 -198.346)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M392.133,450.621a1.061,1.061,0,0,1-.237.383c-.169.169-.35.293-.395.259s.068-.226.248-.395S392.065,450.576,392.133,450.621Z",
    transform: "translate(-258.68 -198.523)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M393.739,450.011a1.052,1.052,0,0,0-.485.147c-.248.147-.417.226-.463.18s.09-.271.406-.372S393.761,449.943,393.739,450.011Z",
    transform: "translate(-258.515 -198.612)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M394.808,449.684c0,.056-.079.147-.214.2s-.271.056-.293,0,.079-.135.214-.192S394.786,449.639,394.808,449.684Z",
    transform: "translate(-258.321 -198.647)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(120.198 247.63)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M397.254,448.77l-16.944.023.011-2.031,16.865-.1Z",
    transform: "translate(-380.31 -446.66)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M423.506,313.479l-6.768,20.306c-1.816,5.471-6.6,6.408-12.409,6.408H367V331.8l34.2-4.885,8.145-20.825Z",
    transform: "translate(-261.817 -217.035)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M365.454,328.125l-2.967-1.4s-3.2-6.193-3.937-5.945-.959,2.064.327,4.918l-3.937-1.128s-8.562,3.948-8.179,4.512a1.974,1.974,0,0,0,2.944.846c1.861-.959,4.3-2.076,4.3-2.076l4.614,1.32-5.945.756-5.64,5.088a2.741,2.741,0,0,0,3.384-.09l14.665,3.091,4.512.248v-8.393Z",
    transform: "translate(-264.411 -215.154)",
    fill: "#b78876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M350.07,333.625a9.6,9.6,0,0,0,.857-.959,4.1,4.1,0,0,1,1.06-.812,4.434,4.434,0,0,1,1.568-.417,20.554,20.554,0,0,0,4.354-.745,22.115,22.115,0,0,0-4.411.293,4.388,4.388,0,0,0-1.726.508,3.676,3.676,0,0,0-1.128.97,2.8,2.8,0,0,0-.575,1.162Z",
    transform: "translate(-263.986 -213.885)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M352.1,333.941c.056,0,.1-.3.508-.395s1.072-.147,1.76-.214a15.54,15.54,0,0,0,2.549-.259,5.11,5.11,0,0,0-2.595-.2,7.83,7.83,0,0,0-1.827.384.733.733,0,0,0-.44.451C352,333.862,352.064,333.941,352.1,333.941Z",
    transform: "translate(-263.735 -213.615)",
    fill: "#aa6550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M422.3,313.388l-2.877,9.758-18.275-8.314c.666-2.042,3.689-11.134,9.465-25.562a24.818,24.818,0,0,1,18.941-15.274,108.45,108.45,0,0,1,17.5-1.715c10.254.113,25.337,6.52,27.356,16.56,1.557,7.671.056,21.208.056,37.656l-1.286,31.462-52.512,1.771Z",
    transform: "translate(-257.443 -221.366)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(178.046 97.305)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M470.509,313.986c-6.385,1.309-12.95,0-19.46-.395-3.948-.237-8.325-.666-11.45,1.76-2.471,1.929-3.463,5.167-4.185,8.213C432.7,335.206,432.2,343,431.59,354.936l31.586,1.918Z",
    transform: "translate(-431.59 -313.403)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M418.71,278.492a6.918,6.918,0,0,1,4.422,2.865,10.153,10.153,0,0,1,1.8,5.471,33.837,33.837,0,0,1-.553,7.2,121.893,121.893,0,0,1-2.933,12.871c-.429,1.579-.79,2.877-1.06,3.869a8.312,8.312,0,0,0-.338,1.433,7.976,7.976,0,0,0,.508-1.388c.293-.9.711-2.2,1.2-3.824a98.14,98.14,0,0,0,3.08-12.894,32.993,32.993,0,0,0,.519-7.3,10.379,10.379,0,0,0-1.963-5.64,7.22,7.22,0,0,0-3.226-2.425,6.162,6.162,0,0,0-1.072-.248C418.845,278.48,418.71,278.469,418.71,278.492Z",
    transform: "translate(-255.194 -220.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M401.66,307.83a18.333,18.333,0,0,0,2.572,1.478c1.624.846,3.892,1.963,6.441,3.114s4.9,2.109,6.611,2.764a15.794,15.794,0,0,0,2.809.948,21.514,21.514,0,0,0-2.7-1.241c-1.67-.733-3.993-1.737-6.532-2.888s-4.828-2.256-6.486-2.989a19.847,19.847,0,0,0-2.719-1.185Z",
    transform: "translate(-257.378 -216.812)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M395.347,351.92a18.715,18.715,0,0,0-7.637,25.066l45.721,78.47,21.084-12.736-35.49-70.844,25.687-16.8",
    transform: "translate(-259.435 -211.165)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M452.744,348.47,390,350.726a18.715,18.715,0,0,0-18.049,19l2.606,89.6h26.386l-.88-84.719,52.682-1.388Z",
    transform: "translate(-261.183 -211.607)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M396.87,374.27a4.359,4.359,0,0,1,.079.835q0,.9.1,2.369c.079,2.064.158,5.054.237,8.754.158,7.389.259,17.6.316,28.868s.113,21.434.147,28.868c0,3.655,0,6.622.056,8.754v2.38a4.4,4.4,0,0,1,0,.835,4.514,4.514,0,0,1-.079-.835c0-.6-.056-1.388-.1-2.38-.079-2.064-.158-5.054-.237-8.743-.158-7.389-.26-17.6-.316-28.879s-.113-21.434-.147-28.868V375.093A4.3,4.3,0,0,1,396.87,374.27Z",
    transform: "translate(-257.991 -208.302)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M476.774,298.07H457.788a13.83,13.83,0,0,0-13.83,13.83v66.185h-37.87a9.577,9.577,0,0,0-9.578,9.577h86.581a7.9,7.9,0,0,0,7.569-7.9V311.9a13.83,13.83,0,0,0-13.887-13.83Z",
    transform: "translate(-258.037 -218.062)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M443.493,300c.158,0,.293,19.46.293,43.465s-.135,43.465-.293,43.465-.293-19.46-.293-43.465S443.335,300,443.493,300Z",
    transform: "translate(-252.057 -217.815)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M444.689,447.028V377.56h-6.171v69.468c-3.768,7.423-12.623,12.409-23.408,16.56h55.006C458.981,459.053,448.829,455.567,444.689,447.028Z",
    transform: "translate(-255.655 -207.88)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    transform: "translate(117.33 279.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M135.146,449.871l.181-.406.553-1.184a31.168,31.168,0,0,0,1.624-4.715,41.672,41.672,0,0,0-.147-18.219,98.658,98.658,0,0,0-3.384-12.24c-1.433-4.343-3.091-8.946-4.512-13.932a53.969,53.969,0,0,1-2.188-16.019c.2-5.64,1.884-11.281,3.723-16.921s3.745-11.146,4.321-16.7a25.427,25.427,0,0,0-3.068-15.421c-2.437-4.512-5.505-8.348-7.806-12.33a42.866,42.866,0,0,1-4.7-11.856,44.278,44.278,0,0,1-.293-18.365,33.844,33.844,0,0,1,1.918-6.487,3.167,3.167,0,0,1-.113.429c-.1.3-.226.711-.395,1.241a48.7,48.7,0,0,0-1.128,4.851,44.627,44.627,0,0,0,.451,18.207,42.552,42.552,0,0,0,4.715,11.71c2.256,3.937,5.381,7.773,7.9,12.33a25.878,25.878,0,0,1,3.159,15.726c-.575,5.64-2.493,11.191-4.332,16.82s-3.5,11.281-3.711,16.8a53.954,53.954,0,0,0,2.143,15.861c1.342,4.952,2.978,9.566,4.4,13.921a95.81,95.81,0,0,1,3.317,12.307,41.22,41.22,0,0,1,0,18.354,27.412,27.412,0,0,1-1.794,4.7c-.259.485-.451.869-.609,1.128a1.648,1.648,0,0,1-.214.406Z",
    transform: "translate(-106.774 -285.08)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M126.758,323.779s-4.67-14.925,3.7-23.69a.519.519,0,0,1,.891.259C131.789,302.83,132.353,310.343,126.758,323.779Z",
    transform: "translate(-105.899 -283.179)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M129.434,304.5a13.879,13.879,0,0,1-.316,2.753c-.316,1.9-.677,4.129-1.128,6.588s-.745,4.693-1.038,6.588a15.907,15.907,0,0,1-.5,2.719,11.449,11.449,0,0,1,.079-2.775c.158-1.7.451-4.05.88-6.622s.869-4.9,1.241-6.577A11.473,11.473,0,0,1,129.434,304.5Z",
    transform: "translate(-105.777 -282.593)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M131.47,354.471s2.854-15.376,14.349-19.177a.508.508,0,0,1,.654.643C145.718,338.351,142.706,345.209,131.47,354.471Z",
    transform: "translate(-105.129 -278.652)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M142.693,338.8a13.4,13.4,0,0,1-1.568,2.256l-4.016,5.325-4,5.325a14.091,14.091,0,0,1-1.715,2.177,11.653,11.653,0,0,1,1.376-2.414c.936-1.433,2.256-3.384,3.869-5.449s3.068-3.914,4.163-5.223a11.786,11.786,0,0,1,1.9-2Z",
    transform: "translate(-105.139 -278.199)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M128.723,389.063S127,373.518,136.879,366.5a.519.519,0,0,1,.823.429C137.669,369.468,136.789,376.947,128.723,389.063Z",
    transform: "translate(-105.495 -274.664)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M135.031,370.7a13.662,13.662,0,0,1-.835,2.64L131.94,379.6c-.857,2.346-1.624,4.512-2.256,6.272a15.642,15.642,0,0,1-1,2.572,11.279,11.279,0,0,1,.609-2.707c.474-1.647,1.218-3.892,2.121-6.34s1.794-4.636,2.471-6.2a11.835,11.835,0,0,1,1.151-2.493Z",
    transform: "translate(-105.486 -274.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M136.394,423.434s-1.128-15.6,8.957-22.223a.508.508,0,0,1,.8.451C146.028,404.166,144.878,411.6,136.394,423.434Z",
    transform: "translate(-104.503 -270.217)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M143.356,405.31a14.066,14.066,0,0,1-.936,2.617c-.722,1.782-1.579,3.869-2.516,6.171s-1.794,4.4-2.516,6.182a14.237,14.237,0,0,1-1.128,2.538,12.287,12.287,0,0,1,.711-2.685c.53-1.624,1.354-3.835,2.358-6.25s1.952-4.58,2.685-6.126a12.142,12.142,0,0,1,1.342-2.448Z",
    transform: "translate(-104.515 -269.68)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M122.266,311.708s-13.864-7.276-14.146-19.347a.519.519,0,0,1,.812-.451C111,293.332,116.7,298.25,122.266,311.708Z",
    transform: "translate(-108.12 -284.217)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M110.68,296a13.769,13.769,0,0,1,1.726,2.177l3.9,5.4,3.926,5.392a14.3,14.3,0,0,1,1.579,2.256,11.122,11.122,0,0,1-1.906-2.019c-1.128-1.309-2.549-3.181-4.072-5.3s-2.843-4.072-3.768-5.516A12.262,12.262,0,0,1,110.68,296Z",
    transform: "translate(-107.792 -283.681)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M135.6,340.03s-14.282-6.385-15.286-18.456a.508.508,0,0,1,.778-.485C123.232,322.386,129.222,326.933,135.6,340.03Z",
    transform: "translate(-106.558 -280.478)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M123.08,325a14.045,14.045,0,0,1,1.85,2.053l4.23,5.167c1.591,1.918,3.023,3.655,4.242,5.144a14.991,14.991,0,0,1,1.715,2.166,11.6,11.6,0,0,1-2.019-1.9c-1.128-1.241-2.741-3.023-4.388-5.054s-3.091-3.892-4.106-5.268A12.412,12.412,0,0,1,123.08,325Z",
    transform: "translate(-106.203 -279.967)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M127.3,372.274s-9.8-12.195-5.2-23.4a.508.508,0,0,1,.914-.079C124.333,350.931,127.6,357.71,127.3,372.274Z",
    transform: "translate(-106.486 -276.951)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M122.82,353.24a13.884,13.884,0,0,1,.711,2.685c.417,1.873.891,4.084,1.421,6.52s1.015,4.625,1.433,6.509a14.933,14.933,0,0,1,.541,2.719,10.707,10.707,0,0,1-.936-2.617c-.485-1.647-1.06-3.937-1.613-6.5s-.981-4.873-1.252-6.554A12.408,12.408,0,0,1,122.82,353.24Z",
    transform: "translate(-106.237 -276.35)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M136.88,409.078s-14.169-6.644-14.97-18.715a.519.519,0,0,1,.79-.474C124.821,391.22,130.743,395.868,136.88,409.078Z",
    transform: "translate(-106.353 -271.665)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M124.62,393.87a14.348,14.348,0,0,1,1.816,2.1l4.151,5.223c1.545,1.952,2.956,3.711,4.151,5.212a16.076,16.076,0,0,1,1.681,2.256,12.187,12.187,0,0,1-2-1.94c-1.128-1.263-2.685-3.068-4.3-5.122s-3.023-3.937-4.016-5.336a12.274,12.274,0,0,1-1.489-2.391Z",
    transform: "translate(-106.006 -271.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M163.272,352.36v1.354q-.068,1.4-.169,3.79c-.181,3.384-.44,7.987-.745,13.537h0c-1.015,5.64-3.892,11.924-7.773,18.049-2.843,4.512-5.81,8.573-8.382,12.409a86.449,86.449,0,0,0-6.283,10.4,43.422,43.422,0,0,0-2.944,7.626c-.248.936-.44,1.658-.541,2.155a4.2,4.2,0,0,1-.214.756,3.666,3.666,0,0,1,.09-.778c.079-.508.226-1.241.44-2.189a40.373,40.373,0,0,1,2.8-7.75,81.738,81.738,0,0,1,6.2-10.514c2.549-3.824,5.516-7.9,8.337-12.409,3.858-6.058,6.769-12.24,7.773-17.812h0c.384-5.562.711-10.153.948-13.537.124-1.579.226-2.843.3-3.779a9.391,9.391,0,0,1,.1-.993,1.309,1.309,0,0,1,.056-.316Z",
    transform: "translate(-104.52 -276.462)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M153.074,386.638s6-14.439-1.545-23.9a.508.508,0,0,0-.9.169C150.005,365.317,148.719,372.751,153.074,386.638Z",
    transform: "translate(-102.761 -275.16)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M151.766,367.17a12.816,12.816,0,0,1,.474,2.73c.214,1.7.451,4.05.632,6.656s.282,4.975.271,6.678a12.341,12.341,0,0,1-.158,2.775,14.349,14.349,0,0,1-.248-2.752c-.135-1.918-.282-4.174-.451-6.656s-.327-4.738-.463-6.656a12.938,12.938,0,0,1-.056-2.775Z",
    transform: "translate(-102.535 -274.565)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(47.197 87.363)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M153.074,386.638s6-14.439-1.545-23.9a.508.508,0,0,0-.9.169C150.005,365.317,148.719,372.751,153.074,386.638Z",
    transform: "translate(-149.957 -362.524)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M136.778,417.469s4.806-14.879-3.486-23.69a.519.519,0,0,0-.891.248C131.984,396.475,131.3,403.977,136.778,417.469Z",
    transform: "translate(-105.045 -271.179)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M133.921,398.17a12.068,12.068,0,0,1,.7,2.685c.35,1.67.778,3.993,1.128,6.577s.677,4.93.812,6.633a11.28,11.28,0,0,1,0,2.775,15.636,15.636,0,0,1-.462-2.73c-.282-1.9-.62-4.129-.981-6.588s-.711-4.7-1-6.6a13.681,13.681,0,0,1-.192-2.753Z",
    transform: "translate(-104.816 -270.595)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(27.082 122.432)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M136.778,417.469s4.806-14.879-3.486-23.69a.519.519,0,0,0-.891.248C131.984,396.475,131.3,403.977,136.778,417.469Z",
    transform: "translate(-132.126 -393.611)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M159.5,370.688s12.815-8.968,11.518-21.005a.519.519,0,0,0-.857-.338C168.3,351.025,163.279,356.632,159.5,370.688Z",
    transform: "translate(-101.538 -276.865)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(57.962 72.352)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M159.5,370.688s12.815-8.968,11.518-21.005a.519.519,0,0,0-.857-.338C168.3,351.025,163.279,356.632,159.5,370.688Z",
    transform: "translate(-159.5 -349.217)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M168.694,353.61a12.77,12.77,0,0,1-1.072,2.561c-.722,1.545-1.782,3.666-3.023,5.956s-2.437,4.343-3.384,5.787a10.808,10.808,0,0,1-1.624,2.256,16.616,16.616,0,0,1,1.275-2.459c.925-1.681,2-3.655,3.193-5.843s2.256-4.174,3.181-5.866A13.3,13.3,0,0,1,168.694,353.61Z",
    transform: "translate(-101.527 -276.302)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M140.83,403.325s15.455-2.414,19.595-13.785a.519.519,0,0,0-.62-.688C157.39,389.552,150.407,392.406,140.83,403.325Z",
    transform: "translate(-103.93 -271.79)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(36.9 117.043)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M140.83,403.325s15.455-2.414,19.595-13.785a.519.519,0,0,0-.62-.688C157.39,389.552,150.407,392.406,140.83,403.325Z",
    transform: "translate(-140.83 -388.834)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M156.354,392.13a12.408,12.408,0,0,1-2.087,1.839c-1.331,1.06-3.215,2.493-5.347,4s-4.095,2.82-5.55,3.723a11.043,11.043,0,0,1-2.459,1.3,13.876,13.876,0,0,1,2.256-1.647L148.6,397.5l5.437-3.869a14.378,14.378,0,0,1,2.313-1.5Z",
    transform: "translate(-103.92 -271.368)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    "data-name": "Path 2614",
    d: "M128.272,426.9l-4.512,30.345h28.1L148.217,426.9Z",
    transform: "translate(-106.116 -266.915)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M148.992,435.267a107.174,107.174,0,0,1-11.281.293,107.174,107.174,0,0,1-11.281-.293,110.919,110.919,0,0,1,11.281-.293,110.9,110.9,0,0,1,11.281.293Z",
    transform: "translate(-105.774 -265.885)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M149.588,437.4a114.644,114.644,0,0,1-11.71.293,114.321,114.321,0,0,1-11.7-.293c0-.158,5.234-.293,11.7-.293S149.588,437.245,149.588,437.4Z",
    transform: "translate(-105.806 -265.607)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Low_code_development-pana",
    "data-name": "Low code development-pana",
    transform: "translate(575.427 -38.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-2",
    transform: "translate(9.362 107.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M545.25,222.729v93.028a5,5,0,0,0,5,5H610.22a5,5,0,0,0,5-5V222.729a5,5,0,0,0-5-5H550.249A5,5,0,0,0,545.25,222.729Z",
    transform: "translate(-545.034 -217.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M545.188,222.7a1.524,1.524,0,0,1,0-.218,4,4,0,0,1,.055-.653,5.014,5.014,0,0,1,4.664-4.175h5.675l36.159-.062h18.348a5.185,5.185,0,0,1,5.053,3.841,6.129,6.129,0,0,1,.179,1.718V315.8a5.232,5.232,0,0,1-1.85,3.98,5.146,5.146,0,0,1-1.975,1.042,7.881,7.881,0,0,1-2.2.187h-58.86a5.683,5.683,0,0,1-1.9-.272,5.178,5.178,0,0,1-2.9-2.395,5.326,5.326,0,0,1-.6-1.8,16.552,16.552,0,0,1-.054-1.85q0-1.819,0-3.615V272.2c0-15.261.047-27.615.062-36.159,0-4.26,0-7.572.039-9.827v0c0,2.255,0,5.566.039,9.827,0,8.552,0,20.9.062,36.159v42.487a15.2,15.2,0,0,0,.054,1.8,4.759,4.759,0,0,0,.552,1.672,4.844,4.844,0,0,0,2.7,2.223,5.27,5.27,0,0,0,1.788.249h58.875a7.416,7.416,0,0,0,2.091-.179,4.587,4.587,0,0,0,1.827-.956,4.851,4.851,0,0,0,1.7-3.67c0-23.323,0-45.48,0-65.662V223.18a5.441,5.441,0,0,0-.163-1.633,4.851,4.851,0,0,0-4.727-3.6H591.531l-36.159-.062h-5.668a4.945,4.945,0,0,0-4.665,4.066A2.1,2.1,0,0,1,545.188,222.7Z",
    transform: "translate(-544.972 -217.59)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 4.035,
    height: 68.22,
    rx: 2.017,
    transform: "translate(17.661 17.99)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M569.788,308.881a2.075,2.075,0,0,0,1.275-.552c.832-.63.5-2.154.544-3.887,0-3.6,0-8.762-.07-15.129s0-13.994-.054-22.452V242.986a3.575,3.575,0,0,0-.055-.84,1.664,1.664,0,0,0-.373-.692,1.734,1.734,0,0,0-1.469-.56,1.687,1.687,0,0,0-1.368.707,1.625,1.625,0,0,0-.288.731,7.953,7.953,0,0,0,0,.871V267.04c0,8.443,0,16.046-.047,22.445s-.054,11.537-.078,15.137v2.371a1.874,1.874,0,0,0,1.695,1.835h.358a1.81,1.81,0,0,1-.365,0,1.842,1.842,0,0,1-1.011-.35,1.96,1.96,0,0,1-.777-1.555v-2.371c0-3.6-.039-8.762-.07-15.137s0-13.994-.054-22.445v-24.7a2.109,2.109,0,0,1,.373-.941,2.146,2.146,0,0,1,1.741-.9,2.223,2.223,0,0,1,1.819.715,2.138,2.138,0,0,1,.474.886,4.2,4.2,0,0,1,.07.956v23.805c0,8.443,0,16.054-.047,22.452s-.054,11.529-.078,15.129v2.379a2.005,2.005,0,0,1-.645,1.6A1.679,1.679,0,0,1,569.788,308.881Z",
    transform: "translate(-550.004 -222.671)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 4.035,
    height: 68.22,
    rx: 2.017,
    transform: "translate(33.179 17.99)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M589.76,308.888a2.053,2.053,0,0,0,1.267-.552c.84-.63.5-2.154.552-3.887,0-3.6-.047-8.762-.078-15.129s0-13.994-.047-22.452V243.062a3.207,3.207,0,0,0-.054-.84,1.508,1.508,0,0,0-.373-.692,1.718,1.718,0,0,0-1.461-.56,1.672,1.672,0,0,0-1.368.707,1.626,1.626,0,0,0-.288.731,7.819,7.819,0,0,0,0,.871v23.859c0,8.443,0,16.046-.054,22.445s-.054,11.537-.07,15.137v2.371a1.889,1.889,0,0,0,1.695,1.835h.365a1.879,1.879,0,0,1-.365,0,1.858,1.858,0,0,1-1.018-.35,1.982,1.982,0,0,1-.777-1.555c0-.692,0-1.485,0-2.371,0-3.6-.047-8.762-.078-15.137s0-13.994-.047-22.445V242.3a2.2,2.2,0,0,1,.373-.941,2.161,2.161,0,0,1,1.749-.9,2.2,2.2,0,0,1,1.811.715,2.137,2.137,0,0,1,.474.886,3.47,3.47,0,0,1,.07.956v23.813c0,8.443,0,16.054-.054,22.452s-.054,11.529-.07,15.129v2.379a2.006,2.006,0,0,1-.637,1.6A1.687,1.687,0,0,1,589.76,308.888Z",
    transform: "translate(-554.451 -222.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 4.035,
    height: 68.22,
    rx: 2.017,
    transform: "translate(48.704 17.99)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2759",
    "data-name": "Path 2759",
    d: "M609.709,308.881a2.075,2.075,0,0,0,1.275-.552c.832-.63.5-2.154.544-3.887,0-3.6-.039-8.762-.07-15.129s0-13.994-.054-22.452V242.986a3.578,3.578,0,0,0-.054-.84,1.663,1.663,0,0,0-.373-.692,1.726,1.726,0,0,0-1.462-.56,1.687,1.687,0,0,0-1.376.707,1.626,1.626,0,0,0-.288.731,7.938,7.938,0,0,0,0,.871V267.04c0,8.443,0,16.046-.047,22.445s-.054,11.537-.07,15.137v2.371a1.874,1.874,0,0,0,1.695,1.835h.358a1.809,1.809,0,0,1-.365,0,1.858,1.858,0,0,1-1.011-.35,1.959,1.959,0,0,1-.816-1.555c0-.692,0-1.485,0-2.371,0-3.6,0-8.762-.07-15.137s0-13.994-.054-22.445v-24.7a2.106,2.106,0,0,1,.373-.941,2.146,2.146,0,0,1,1.749-.9,2.208,2.208,0,0,1,1.811.715,2.139,2.139,0,0,1,.474.886,4.211,4.211,0,0,1,.07.956v23.805c0,8.443,0,16.054-.047,22.452s-.054,11.529-.078,15.129v2.379a2.006,2.006,0,0,1-.645,1.6,1.679,1.679,0,0,1-1.469.529Z",
    transform: "translate(-558.882 -222.671)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M568.665,279.612h-.777A3.887,3.887,0,0,1,564,275.686h0a3.887,3.887,0,0,1,3.887-3.926h.777a3.887,3.887,0,0,1,3.887,3.926h0a3.887,3.887,0,0,1-3.887,3.926Z",
    transform: "translate(-549.207 -229.646)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M589.885,298.654h-.777a3.887,3.887,0,0,1-3.887-3.887h0a3.887,3.887,0,0,1,3.887-3.887h.777a3.887,3.887,0,0,1,3.887,3.887h0A3.887,3.887,0,0,1,589.885,298.654Z",
    transform: "translate(-553.93 -233.902)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2762",
    "data-name": "Path 2762",
    d: "M609.125,262.763h-.777a3.887,3.887,0,0,1-3.887-3.887h0a3.887,3.887,0,0,1,3.887-3.926h.777a3.887,3.887,0,0,1,3.887,3.926h0A3.887,3.887,0,0,1,609.125,262.763Z",
    transform: "translate(-558.212 -225.905)",
    fill: "#c8102e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Colors--inject-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 96.083,
    height: 96.083,
    rx: 8.33,
    transform: "translate(0.132 0.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2763",
    "data-name": "Path 2763",
    d: "M622.669,175.763a7.325,7.325,0,0,0,.956-.093,6.709,6.709,0,0,0,2.6-1.018,6.476,6.476,0,0,0,2.612-3.623,9.585,9.585,0,0,0,.233-2.892v-3.343c0-9.446-.039-23.113-.062-39.991V85.728a6.274,6.274,0,0,0-4.533-5.636,14.958,14.958,0,0,0-3.98-.249H539.546a6.282,6.282,0,0,0-6.219,5.722c-.062,3.11,0,6.328,0,9.454v73.833a6.483,6.483,0,0,0,.879,3.623,5.839,5.839,0,0,0,1.112,1.431,5.615,5.615,0,0,0,1.555,1.034,7.23,7.23,0,0,0,3.584.63H568.07l39.991.062,10.884.039h0l-10.884.039-39.991.062H540.456a7.611,7.611,0,0,1-3.732-.653,6.454,6.454,0,0,1-1.609-1.088,6.29,6.29,0,0,1-1.236-1.555,6.873,6.873,0,0,1-.941-3.8V85.347a6.694,6.694,0,0,1,6.655-6.087h82.929a7.036,7.036,0,0,1,2.045.264,6.647,6.647,0,0,1,4.781,5.963c.047,1.322,0,2.6,0,3.887v35.187c0,16.878-.054,30.545-.07,39.991V167.9a9.909,9.909,0,0,1-.256,2.931,6.531,6.531,0,0,1-2.69,3.654,6.453,6.453,0,0,1-2.635.987,4.9,4.9,0,0,1-.723.054A1.919,1.919,0,0,1,622.669,175.763Z",
    transform: "translate(-532.93 -79.258)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2764",
    "data-name": "Path 2764",
    d: "M595.265,131.673h-10.06a8.855,8.855,0,0,1-8.855-8.878V101.12h27.778v21.675a8.855,8.855,0,0,1-8.863,8.878Z",
    transform: "translate(-542.594 -84.124)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2765",
    "data-name": "Path 2765",
    d: "M595.2,131.555a13.993,13.993,0,0,0,2.573-.474,9.011,9.011,0,0,0,2.721-1.454,8.607,8.607,0,0,0,2.558-3.211,10.162,10.162,0,0,0,.777-5c0-1.881,0-3.887,0-6.064V101l.264.272H576.283l.28-.288v22.071a8.553,8.553,0,0,0,.9,3.522,8.645,8.645,0,0,0,4.773,4.26c1.881.723,3.763.5,5.372.552l4.128.047,2.589.054h0l-2.589.054-4.128.039h-2.589a9.034,9.034,0,0,1-8.933-8.622c-.047-1.314,0-2.636-.039-4.019V100.59h28.338v20.688a10.364,10.364,0,0,1-.91,5.139,8.746,8.746,0,0,1-2.7,3.281,9.1,9.1,0,0,1-2.822,1.415A7.254,7.254,0,0,1,595.2,131.555Z",
    transform: "translate(-542.527 -84.006)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    "data-name": "Path 2766",
    d: "M576.53,101.381c4.043,2.946,8.21,4.882,13.216,4.781a24.783,24.783,0,0,0,14.429-4.812Z",
    transform: "translate(-542.634 -84.175)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    "data-name": "Path 2767",
    d: "M604.824,106.85a3.291,3.291,0,0,1,.2.6c.124.459.28,1.034.466,1.741.4,1.555.964,3.771,1.633,6.422.342,1.361.707,2.845,1.1,4.439.187.777.42,1.555.583,2.5a5.092,5.092,0,0,1-.373,2.783,5.2,5.2,0,0,1-4.828,3.164l-6.219.039h-3.156a13.558,13.558,0,0,1-3.11-.187,8.824,8.824,0,0,1-6.437-5.442c-.326-.84-.583-1.633-.863-2.41-.536-1.555-1.042-2.993-1.5-4.323l-2.138-6.274c-.225-.692-.4-1.259-.552-1.718a2.455,2.455,0,0,1-.156-.606,2.673,2.673,0,0,1,.264.568l.653,1.679,2.332,6.219,1.555,4.3a14,14,0,0,0,2.224,4.618,8.31,8.31,0,0,0,4.742,2.814,13.543,13.543,0,0,0,3,.163h9.376a4.813,4.813,0,0,0,2.651-.777,4.664,4.664,0,0,0,1.695-2.029,4.6,4.6,0,0,0,.358-2.5c-.132-.777-.373-1.671-.544-2.464-.373-1.555-.715-3.11-1.034-4.455-.6-2.674-1.088-4.859-1.454-6.468l-.365-1.765A2.194,2.194,0,0,1,604.824,106.85Z",
    transform: "translate(-543.291 -85.399)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    "data-name": "Path 2768",
    d: "M580.83,107.955a1.555,1.555,0,1,1-1.555-1.555A1.555,1.555,0,0,1,580.83,107.955Z",
    transform: "translate(-542.899 -85.299)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2769",
    "data-name": "Path 2769",
    d: "M606.933,101.478c.148.653-.777,1.267-.731,1.944a3,3,0,0,1-1.928,2.853.777.777,0,0,0-.264.148,2.861,2.861,0,0,0-.777,1.912l-.513,3.483a5.856,5.856,0,0,1-.575,2.1,2,2,0,0,1-1.757,1.1c-1.057-.07-1.71-1.205-1.866-2.247-.2-1.306.054-2.705-.84-3.833a1.555,1.555,0,0,0-1.741-.583c-1.555.583-.622,3.11-2.13,3.7a1.392,1.392,0,0,1-1.275-.187,3.615,3.615,0,0,1-1.236-2.332q-.513-2.037-1.018-4.1l16.676-3.973",
    transform: "translate(-545.694 -84.202)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308",
    "data-name": "Ellipse 308",
    cx: 8.591,
    cy: 8.591,
    r: 8.591,
    transform: "translate(12.975 58.371)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    cx: 8.591,
    cy: 8.591,
    r: 8.591,
    transform: "translate(39.587 58.371)",
    fill: "#8b0b1f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 8.591,
    cy: 8.591,
    r: 8.591,
    transform: "translate(66.191 58.371)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(12.975 58.371)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_311",
    "data-name": "Ellipse 311",
    cx: 8.591,
    cy: 8.591,
    r: 8.591,
    fill: "#c8102e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(66.191 58.371)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_312",
    "data-name": "Ellipse 312",
    cx: 8.591,
    cy: 8.591,
    r: 8.591
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    "data-name": "Path 2770",
    d: "M566.737,162.879a17.161,17.161,0,0,0-.35-2.076,8.551,8.551,0,0,0-3.11-4.665A8.412,8.412,0,0,0,555.293,155a7.952,7.952,0,0,0-2.122,1.151,7.861,7.861,0,0,0-1.765,1.765,8.358,8.358,0,0,0,0,9.9,7.858,7.858,0,0,0,1.773,1.78,7.953,7.953,0,0,0,2.122,1.151,8.551,8.551,0,0,0,4.408.381,8.342,8.342,0,0,0,3.553-1.555,8.551,8.551,0,0,0,3.11-4.626,17.77,17.77,0,0,0,.35-2.076,6.6,6.6,0,0,1-.187,2.115,8.686,8.686,0,0,1-11.4,6.134,8.209,8.209,0,0,1-2.223-1.189,8.46,8.46,0,0,1-1.866-1.858,8.731,8.731,0,0,1,0-10.4,8.294,8.294,0,0,1,1.866-1.858,8,8,0,0,1,2.223-1.189,8.723,8.723,0,0,1,8.28,1.3,8.591,8.591,0,0,1,3.11,4.836A6.6,6.6,0,0,1,566.737,162.879Z",
    transform: "translate(-536.58 -95.917)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2771",
    "data-name": "Path 2771",
    d: "M600.963,162.872a17.185,17.185,0,0,0-.35-2.076,8.551,8.551,0,0,0-3.11-4.665,8.412,8.412,0,0,0-7.961-1.174,7.953,7.953,0,0,0-2.122,1.151,7.83,7.83,0,0,0-1.765,1.78,8.4,8.4,0,0,0,3.887,12.835,8.552,8.552,0,0,0,4.408.381,8.342,8.342,0,0,0,3.553-1.555,8.553,8.553,0,0,0,3.11-4.626,17.745,17.745,0,0,0,.35-2.076,6.6,6.6,0,0,1-.187,2.115A8.661,8.661,0,0,1,594,171.455a8.754,8.754,0,0,1-4.61-.358,8.14,8.14,0,0,1-2.231-1.189,8.265,8.265,0,0,1-1.858-1.858,8.741,8.741,0,1,1,15.479-7.316A6.6,6.6,0,0,1,600.963,162.872Z",
    transform: "translate(-544.203 -95.911)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    d: "M635.165,162.874a17.2,17.2,0,0,0-.35-2.076,8.552,8.552,0,0,0-6.686-6.219,8.412,8.412,0,0,0-4.408.381,7.953,7.953,0,0,0-2.122,1.151,7.705,7.705,0,0,0-1.773,1.78,8.357,8.357,0,0,0,0,9.9,7.859,7.859,0,0,0,1.773,1.78,7.952,7.952,0,0,0,2.122,1.151,8.552,8.552,0,0,0,4.408.381,8.342,8.342,0,0,0,3.553-1.555,8.552,8.552,0,0,0,3.11-4.626,17.758,17.758,0,0,0,.35-2.076,6.6,6.6,0,0,1-.187,2.115,8.686,8.686,0,0,1-11.4,6.134,8.211,8.211,0,0,1-2.223-1.189,8.46,8.46,0,0,1-1.866-1.858,8.731,8.731,0,0,1,0-10.4,8.3,8.3,0,0,1,1.866-1.858,8,8,0,0,1,2.224-1.189,8.723,8.723,0,0,1,8.28,1.3,8.59,8.59,0,0,1,3.11,4.836A6.6,6.6,0,0,1,635.165,162.874Z",
    transform: "translate(-551.808 -95.913)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Invoice-pana",
    transform: "translate(203.602 124.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3001",
    "data-name": "Path 3001",
    d: "M410.5,196.75c-1.7,0-2.886-1.25-2.886-3.265s1.187-3.265,2.886-3.265,2.907,1.271,2.907,3.265S412.2,196.75,410.5,196.75Zm0-1.387c.72,0,1.218-.625,1.218-1.878s-.5-1.878-1.218-1.878-1.218.611-1.218,1.878S409.767,195.363,410.5,195.363Zm1.018,6.832h-1.984l-7.994-11.839h1.987Zm-8.946.137c-1.7,0-2.9-1.267-2.9-3.265s1.2-3.265,2.9-3.265,2.889,1.271,2.889,3.265-1.2,3.265-2.889,3.265Zm0-1.387c.72,0,1.218-.611,1.218-1.878s-.5-1.878-1.218-1.878-1.218.625-1.218,1.878S401.84,200.946,402.573,200.946Z",
    transform: "translate(-399.67 -190.22)",
    fill: "#c8102e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Invoice-pana-2",
    "data-name": "Invoice-pana",
    transform: "translate(395.549 297.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17-2",
    "data-name": "freepik--speech-bubble--inject-17",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3001-2",
    "data-name": "Path 3001",
    d: "M403.271,192.391a1.093,1.093,0,1,1,.966-1.086A.967.967,0,0,1,403.271,192.391Zm0-.461c.239,0,.405-.208.405-.625s-.166-.624-.405-.624-.405.2-.405.624S403.027,191.93,403.271,191.93Zm.339,2.272h-.66l-2.658-3.936h.661Zm-2.974.046a1.094,1.094,0,1,1,.961-1.086A.974.974,0,0,1,400.635,194.247Zm0-.461c.239,0,.405-.2.405-.624s-.166-.625-.405-.625-.405.208-.405.625S400.391,193.786,400.635,193.786Z",
    transform: "translate(-399.67 -190.22)",
    fill: "#c8102e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Invoice-bro",
    transform: "translate(193.149 79.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    width: 16.769,
    height: 16.769,
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M50.555,373.906H46.287V369.63H44.476v4.276H40.2v1.811h4.276v4.268h1.811v-4.268h4.268Z",
    transform: "translate(-36.997 -366.808)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    width: 16.769,
    height: 16.769,
    transform: "translate(16.73)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    width: 8.933,
    height: 1.555,
    transform: "translate(20.649 7.098)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732",
    "data-name": "Rectangle 732",
    width: 16.769,
    height: 16.769,
    transform: "translate(0 16.738)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M48.653,392.28,45.629,395.3l-3.016-3.024-1.283,1.283,3.024,3.024L41.33,399.6l1.283,1.283,3.016-3.024,3.024,3.024,1.283-1.283-3.024-3.016,3.024-3.024Z",
    transform: "translate(-37.249 -371.849)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    width: 16.769,
    height: 16.769,
    transform: "translate(16.73 16.738)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    width: 8.933,
    height: 1.555,
    transform: "translate(20.649 23.828)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_317",
    "data-name": "Ellipse 317",
    cx: 1.12,
    cy: 1.12,
    r: 1.12,
    transform: "translate(23.991 20.167)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M68.057,400.7a1.127,1.127,0,1,0,1.127,1.127A1.127,1.127,0,0,0,68.057,400.7Z",
    transform: "translate(-42.946 -373.723)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(114.661 77.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(0 8.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(0.004 7.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M345.88,97.113H317.2V77.04h28.68Zm-28.311-.368h27.939V77.413H317.568Z",
    transform: "translate(-317.045 -76.877)",
    fill: "#a6a8a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M345.664,97.041h-28.68a.155.155,0,0,1-.155-.159V76.809a.158.158,0,0,1,.155-.159h28.68a.159.159,0,0,1,.159.159V96.882A.159.159,0,0,1,345.664,97.041Zm-28.525-.314h28.366V76.968H317.14Zm28.152-.054H317.353a.155.155,0,0,1-.155-.159V77.182a.158.158,0,0,1,.155-.159h27.939a.155.155,0,0,1,.155.159V96.513A.158.158,0,0,1,345.292,96.673Zm-27.784-.314h27.625V77.341H317.508Z",
    transform: "translate(-316.83 -76.65)",
    fill: "#a6a8a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(28.315 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M385.014,86.486a.165.165,0,0,1-.088-.025.19.19,0,0,1-.1-.163v-19.7a.183.183,0,0,1,.088-.155l12.215-7.648a.18.18,0,0,1,.188,0,.19.19,0,0,1,.1.163v19.7a.183.183,0,0,1-.088.155l-12.215,7.648A.167.167,0,0,1,385.014,86.486ZM385.2,66.7V85.967l11.847-7.414V59.284L385.2,66.7Z",
    transform: "translate(-384.675 -58.603)",
    fill: "#a6a8a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M384.8,86.421a.317.317,0,0,1-.163-.042.347.347,0,0,1-.176-.3v-19.7a.339.339,0,0,1,.159-.289l12.215-7.648a.343.343,0,0,1,.523.289v19.7a.339.339,0,0,1-.159.289l-12.215,7.648a.344.344,0,0,1-.18.05ZM397,58.7h0l-12.215,7.648-.013,19.725.029.029s.013,0,.017,0l12.215-7.648.013-19.725h0L397,58.7ZM384.983,85.9a.171.171,0,0,1-.075-.021.157.157,0,0,1-.08-.138V66.478a.16.16,0,0,1,.075-.134l11.847-7.414a.156.156,0,0,1,.239.134V78.329a.16.16,0,0,1-.075.134l-11.847,7.414A.151.151,0,0,1,384.983,85.9Zm.159-19.336v18.9l11.533-7.217v-18.9l-11.533,7.217Z",
    transform: "translate(-384.46 -58.383)",
    fill: "#a6a8a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0.089 0.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M317.607,86.717l-.2-.314,1.884-1.18.2.314Zm2.512-1.57-.2-.314,1.884-1.18.2.314Zm2.512-1.574-.2-.314,1.884-1.181.2.314ZM325.142,82l-.2-.314,1.884-1.18.2.314Zm2.512-1.57-.2-.314,1.884-1.181.2.314Zm2.256-1.917h-.368V76.294h.368Zm0-2.964h-.368V73.33h.368Zm0-2.964h-.368V70.366h.368Zm0-2.964h-.368V67.4h.368Zm0-2.964h-.368V64.439h.368Zm0-2.964h-.368V61.475h.368Zm0-2.964h-.368V59.21h.368Z",
    transform: "translate(-317.252 -59.034)",
    fill: "#a6a8a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    "data-name": "Path 3126",
    d: "M317.387,86.628a.156.156,0,0,1-.134-.075l-.2-.314a.165.165,0,0,1-.021-.117.139.139,0,0,1,.071-.1l1.884-1.181a.157.157,0,0,1,.218.05l.2.314a.165.165,0,0,1,.021.117.14.14,0,0,1-.071.1L317.471,86.6A.151.151,0,0,1,317.387,86.628Zm.021-.423.029.046,1.616-1.013-.029-.046Zm2.491-1.151h-.033a.139.139,0,0,1-.1-.071l-.2-.314a.165.165,0,0,1-.021-.117.139.139,0,0,1,.071-.1l1.884-1.18a.157.157,0,0,1,.218.05l.2.314a.165.165,0,0,1,.021.117.139.139,0,0,1-.071.1l-1.884,1.181a.151.151,0,0,1-.084.025Zm.021-.423.029.046,1.616-1.013-.029-.046Zm2.491-1.151a.156.156,0,0,1-.134-.075l-.2-.314a.165.165,0,0,1-.021-.117.14.14,0,0,1,.071-.1l1.884-1.181a.157.157,0,0,1,.218.05l.2.314a.165.165,0,0,1,.021.117.139.139,0,0,1-.071.1l-1.884,1.181a.151.151,0,0,1-.084.025Zm.021-.423.029.046,1.616-1.013-.029-.046Zm2.491-1.151a.156.156,0,0,1-.134-.075l-.2-.314a.165.165,0,0,1-.021-.117.14.14,0,0,1,.071-.1l1.884-1.181a.157.157,0,0,1,.218.05l.2.314a.165.165,0,0,1,.021.117.139.139,0,0,1-.071.1l-1.884,1.181A.151.151,0,0,1,324.922,81.906Zm.021-.423.029.046,1.616-1.013-.029-.046Zm2.491-1.151a.156.156,0,0,1-.134-.075l-.2-.314a.165.165,0,0,1-.021-.117.139.139,0,0,1,.071-.1l1.884-1.181a.157.157,0,0,1,.218.05l.2.314a.165.165,0,0,1,.021.117.139.139,0,0,1-.071.1l-1.884,1.181a.151.151,0,0,1-.084.025Zm.021-.423.029.046,1.616-1.013-.029-.046Zm2.24-1.494h-.368a.159.159,0,0,1-.159-.159V76.033a.159.159,0,0,1,.159-.159h.368a.155.155,0,0,1,.155.159v2.223A.158.158,0,0,1,329.695,78.415Zm-.214-.314h.054V76.192h-.054Zm.214-2.65h-.368a.159.159,0,0,1-.159-.159V73.069a.159.159,0,0,1,.159-.159h.368a.155.155,0,0,1,.155.159v2.223A.158.158,0,0,1,329.695,75.451Zm-.214-.314h.054V73.228h-.054Zm.214-2.65h-.368a.159.159,0,0,1-.159-.159V70.105a.159.159,0,0,1,.159-.159h.368a.155.155,0,0,1,.155.159v2.223A.158.158,0,0,1,329.695,72.487Zm-.214-.314h.054V70.264h-.054Zm.214-2.65h-.368a.159.159,0,0,1-.159-.159V67.141a.159.159,0,0,1,.159-.159h.368a.155.155,0,0,1,.155.159v2.223A.158.158,0,0,1,329.695,69.523Zm-.214-.314h.054V67.3h-.054Zm.214-2.65h-.368a.159.159,0,0,1-.159-.159V64.178a.159.159,0,0,1,.159-.159h.368a.155.155,0,0,1,.155.159V66.4A.158.158,0,0,1,329.695,66.56Zm-.214-.314h.054V64.337h-.054Zm.214-2.65h-.368a.159.159,0,0,1-.159-.159V61.214a.159.159,0,0,1,.159-.159h.368a.155.155,0,0,1,.155.159v2.223A.158.158,0,0,1,329.695,63.6Zm-.214-.314h.054V61.373h-.054Zm.214-2.65h-.368a.159.159,0,0,1-.159-.159V58.949a.159.159,0,0,1,.159-.159h.368a.155.155,0,0,1,.155.159v1.524A.158.158,0,0,1,329.695,60.632Zm-.214-.314h.054v-1.21h-.054Z",
    transform: "translate(-317.032 -58.79)",
    fill: "#a6a8a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    "data-name": "Path 3127",
    d: "M317.384,86.491a.186.186,0,0,1-.184-.184V66.6a.183.183,0,0,1,.088-.155L329.5,58.8a.2.2,0,0,1,.1-.029h28.311a.184.184,0,1,1,0,.368H329.654L317.568,66.7V86.3a.186.186,0,0,1-.184.184Z",
    transform: "translate(-317.041 -58.611)",
    fill: "#a6a8a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    "data-name": "Path 3128",
    d: "M317.163,86.425a.345.345,0,0,1-.343-.343v-19.7a.339.339,0,0,1,.159-.289l12.215-7.648a.344.344,0,0,1,.18-.05h28.311a.343.343,0,0,1,0,.687H329.475L317.5,66.57V86.082a.345.345,0,0,1-.343.343ZM329.379,58.7l-12.232,7.652-.013,19.725c0,.029.054.029.054,0v-19.6a.16.16,0,0,1,.075-.134l12.086-7.564a.151.151,0,0,1,.084-.025H357.69s.029-.013.029-.029a.029.029,0,0,0-.029-.029H329.379Z",
    transform: "translate(-316.82 -58.39)",
    fill: "#a6a8a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(12.429 19.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    "data-name": "Path 3129",
    d: "M375.12,106.208h-1.645v-.368h1.645Zm-2.386,0h-2.223v-.368h2.223Zm-2.964,0h-2.223v-.368h2.223Zm-2.964,0h-2.223v-.368h2.223Zm-2.964,0h-2.223v-.368h2.223Zm-2.964,0h-2.223v-.368h2.223Zm-2.964,0h-2.223v-.368h2.223Zm-2.964,0h-2.223v-.368h2.223Zm-2.964,0h-2.223v-.368h2.223Zm-2.964,0H346.8v-.368h2.223Z",
    transform: "translate(-346.679 -105.677)",
    fill: "#a6a8a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    "data-name": "Path 3130",
    d: "M374.951,106.137h-1.645a.155.155,0,0,1-.155-.159v-.368a.158.158,0,0,1,.155-.159h1.645a.155.155,0,0,1,.155.159v.368A.158.158,0,0,1,374.951,106.137Zm-1.49-.314h1.331v-.054h-1.331Zm-.9.314h-2.223a.155.155,0,0,1-.155-.159v-.368a.158.158,0,0,1,.155-.159h2.223a.156.156,0,0,1,.155.159v.368A.158.158,0,0,1,372.565,106.137Zm-2.064-.314h1.909v-.054H370.5Zm-.9.314h-2.223a.155.155,0,0,1-.155-.159v-.368a.158.158,0,0,1,.155-.159h2.223a.159.159,0,0,1,.159.159v.368A.159.159,0,0,1,369.605,106.137Zm-2.064-.314h1.909v-.054h-1.909Zm-.9.314h-2.223a.155.155,0,0,1-.155-.159v-.368a.158.158,0,0,1,.155-.159h2.223a.155.155,0,0,1,.155.159v.368A.158.158,0,0,1,366.646,106.137Zm-2.064-.314h1.909v-.054h-1.909Zm-.9.314h-2.223a.155.155,0,0,1-.155-.159v-.368a.158.158,0,0,1,.155-.159h2.223a.156.156,0,0,1,.155.159v.368A.158.158,0,0,1,363.686,106.137Zm-2.064-.314h1.909v-.054h-1.909Zm-.9.314H358.5a.159.159,0,0,1-.159-.159v-.368a.159.159,0,0,1,.159-.159h2.223a.155.155,0,0,1,.155.159v.368A.158.158,0,0,1,360.726,106.137Zm-2.064-.314h1.909v-.054h-1.909Zm-.9.314h-2.223a.155.155,0,0,1-.155-.159v-.368a.158.158,0,0,1,.155-.159h2.223a.155.155,0,0,1,.155.159v.368A.158.158,0,0,1,357.767,106.137Zm-2.064-.314h1.909v-.054H355.7Zm-.9.314h-2.223a.155.155,0,0,1-.155-.159v-.368a.158.158,0,0,1,.155-.159h2.223a.155.155,0,0,1,.155.159v.368A.158.158,0,0,1,354.807,106.137Zm-2.064-.314h1.909v-.054h-1.909Zm-.9.314h-2.223a.155.155,0,0,1-.155-.159v-.368a.158.158,0,0,1,.155-.159h2.223a.155.155,0,0,1,.155.159v.368A.158.158,0,0,1,351.847,106.137Zm-2.064-.314h1.909v-.054h-1.909Zm-.9.314h-2.223a.155.155,0,0,1-.155-.159v-.368a.158.158,0,0,1,.155-.159h2.223a.155.155,0,0,1,.155.159v.368A.158.158,0,0,1,348.888,106.137Zm-2.064-.314h1.909v-.054h-1.909Z",
    transform: "translate(-346.51 -105.45)",
    fill: "#a6a8a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(13.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M351.932,44.855a.38.38,0,0,1-.13.26.4.4,0,0,1-.28.1.456.456,0,0,1-.448-.327q-.339-.848-1.042-2.533a.488.488,0,0,1-.042-.18.368.368,0,0,1,.138-.289.465.465,0,0,1,.314-.117.4.4,0,0,1,.385.247c.121.255.352.846.7,1.779.113-.239.264-.6.46-1.08.059-.163.151-.385.272-.674a.415.415,0,0,1,.389-.251.465.465,0,0,1,.314.117.368.368,0,0,1,.138.289,8.859,8.859,0,0,1-.511,1.243c-.276.615-.494,1.088-.657,1.419Z",
    transform: "translate(-349.99 -40.137)",
    fill: "#a6a8a9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(7.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M371.875,45.308a.9.9,0,0,1-.461-.28,4.012,4.012,0,0,1-.511.209,1.3,1.3,0,0,1-.373.071A1.467,1.467,0,0,1,369.4,44.9a1.934,1.934,0,0,1,.184-2.512,1.862,1.862,0,0,1,1.34-.54,1.758,1.758,0,0,1,.691.167c.318.134.473.293.473.469a.307.307,0,0,1-.071.2,2.249,2.249,0,0,0-.05.314c-.013.126-.017.272-.017.44a3.117,3.117,0,0,0,.084.854c.008.017.054.126.147.322a1.476,1.476,0,0,1,.121.306.343.343,0,0,1-.126.272.446.446,0,0,1-.293.109Zm-.779-2.122c0-.067,0-.142.013-.23s.025-.184.042-.289a.585.585,0,0,0-.113-.046.339.339,0,0,0-.084-.013,1.013,1.013,0,0,0-.749.335,1.087,1.087,0,0,0-.322.774,1.065,1.065,0,0,0,.151.632.517.517,0,0,0,.452.213,1.081,1.081,0,0,0,.368-.063,1.069,1.069,0,0,0,.327-.188,9.939,9.939,0,0,1-.1-1.118Z",
    transform: "translate(-369.02 -40.184)",
    fill: "#a6a8a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M379.342,42.952a2.253,2.253,0,0,1-.837-.155.376.376,0,0,1-.285.117.4.4,0,0,1-.289-.113.379.379,0,0,1-.121-.285c0-.05,0-.126.008-.23s.008-.18.008-.23V38.494a.8.8,0,0,1,.1-.4.391.391,0,0,1,.36-.222c.226,0,.335.121.335.364a.57.57,0,0,1-.013.13,1.064,1.064,0,0,0-.013.13V39.7a2.367,2.367,0,0,1,.448-.193,1.46,1.46,0,0,1,.41-.063,1.488,1.488,0,0,1,1.193.536,1.815,1.815,0,0,1,.423,1.218,1.706,1.706,0,0,1-.494,1.235,1.656,1.656,0,0,1-1.243.519Zm.121-2.708a.961.961,0,0,0-.377.1,2.973,2.973,0,0,0-.481.285V41.96a1.89,1.89,0,0,0,.737.184.865.865,0,0,0,.657-.268.945.945,0,0,0,.26-.678,1.062,1.062,0,0,0-.209-.674.713.713,0,0,0-.586-.276Z",
    transform: "translate(-374.13 -37.87)",
    fill: "#a6a8a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M388.184,45.252a1.73,1.73,0,0,1-1.16-.394,1.352,1.352,0,0,1-.494-1.093,2.336,2.336,0,0,1,.444-1.294,1.419,1.419,0,0,1,1.168-.762,2.077,2.077,0,0,1,.762.176c.356.147.532.31.532.5a.376.376,0,0,1-.109.272.364.364,0,0,1-.293.13.6.6,0,0,1-.327-.147.935.935,0,0,0-.569-.147c-.163,0-.335.159-.523.473a1.635,1.635,0,0,0-.272.791.623.623,0,0,0,.239.519.928.928,0,0,0,.6.18,1.185,1.185,0,0,0,.515-.159,1.212,1.212,0,0,1,.385-.159.415.415,0,0,1,.41.4c0,.163-.18.327-.536.49a1.97,1.97,0,0,1-.779.218Z",
    transform: "translate(-379.2 -40.103)",
    fill: "#a6a8a9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M360.969,44.068h2.173a.224.224,0,0,0,0-.448h-2.173a.224.224,0,0,0,0,.448Z",
    transform: "translate(-356.247 -41.213)",
    fill: "#a6a8a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M360.969,46.938h2.173a.224.224,0,0,0,0-.448h-2.173a.224.224,0,0,0,0,.448Z",
    transform: "translate(-356.247 -42.882)",
    fill: "#a6a8a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(138.771 121.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M329.77,199.237c-.068.058-.153.134-.26.228l-.27.25.539.658a.227.227,0,0,1,.058.143.215.215,0,0,1-.073.16.241.241,0,0,1-.17.068.246.246,0,0,1-.177-.085c-.107-.114-.279-.323-.525-.622-.095.095-.243.233-.442.415q-.095.08-.146.131a.236.236,0,0,1-.175.08.231.231,0,0,1-.168-.068.215.215,0,0,1-.073-.16.361.361,0,0,1,.146-.236c.078-.068.155-.134.233-.2s.185-.182.335-.33c-.066-.092-.131-.185-.2-.274a1.515,1.515,0,0,0-.228-.253.227.227,0,0,1,.146-.4c.083,0,.2.085.345.253l.282.364c.1-.085.2-.17.3-.255a1.793,1.793,0,0,0,.267-.277.224.224,0,0,1,.192-.107.245.245,0,0,1,.17.068.2.2,0,0,1,.075.158.485.485,0,0,1-.185.294Z",
    transform: "translate(-327.89 -191.843)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M383.167,186.042a1.266,1.266,0,0,1-.469-.087.216.216,0,0,1-.158.066.236.236,0,0,1-.163-.063.2.2,0,0,1-.068-.158c0-.029,0-.07,0-.129s0-.1,0-.129v-2a.458.458,0,0,1,.056-.226.222.222,0,0,1,.2-.126q.189,0,.189.2a.323.323,0,0,1-.007.073.593.593,0,0,0-.007.073v.675a1.285,1.285,0,0,1,.25-.109.8.8,0,0,1,.231-.036.833.833,0,0,1,.67.3,1.027,1.027,0,0,1,.238.685.955.955,0,0,1-.277.692.935.935,0,0,1-.7.291Zm.068-1.518a.52.52,0,0,0-.211.053,1.66,1.66,0,0,0-.27.158v.751a1.06,1.06,0,0,0,.415.1.492.492,0,0,0,.369-.151.526.526,0,0,0,.146-.381.584.584,0,0,0-.119-.379.4.4,0,0,0-.328-.155Z",
    transform: "translate(-369.092 -180.085)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M434.327,186.042a1.265,1.265,0,0,1-.469-.087.216.216,0,0,1-.158.066.236.236,0,0,1-.163-.063.2.2,0,0,1-.068-.158c0-.029,0-.07,0-.129s0-.1,0-.129v-2a.458.458,0,0,1,.056-.226.222.222,0,0,1,.2-.126q.189,0,.189.2a.324.324,0,0,1-.007.073.591.591,0,0,0-.007.073v.675a1.284,1.284,0,0,1,.25-.109.8.8,0,0,1,.231-.036.833.833,0,0,1,.67.3,1.027,1.027,0,0,1,.238.685.955.955,0,0,1-.277.692.935.935,0,0,1-.7.291Zm.068-1.518a.52.52,0,0,0-.211.053,1.66,1.66,0,0,0-.27.158v.751a1.06,1.06,0,0,0,.415.1.492.492,0,0,0,.369-.151.526.526,0,0,0,.146-.381.584.584,0,0,0-.119-.379.4.4,0,0,0-.328-.155Z",
    transform: "translate(-407.825 -180.085)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(35.256 3.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M474.31,185.323h-.7c-.376,0-.566-.078-.566-.231a.344.344,0,0,1,.1-.216c.053-.061.109-.124.165-.185q.284-.4.867-1.207a.431.431,0,0,1,.357-.185.3.3,0,0,1,.18.053.2.2,0,0,1,.09.177v1.326a.785.785,0,0,1,.311.049.194.194,0,0,1,.087.187.2.2,0,0,1-.134.2.665.665,0,0,1-.26.029c0,.17,0,.352,0,.551a.218.218,0,0,1-.063.16.227.227,0,0,1-.168.063c-.18,0-.265-.117-.255-.352v-.423Zm0-1.258c-.114.18-.289.445-.527.792h.527Z",
    transform: "translate(-473.04 -183.3)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M484.081,188.973a.515.515,0,0,1-.257-.158,2.553,2.553,0,0,1-.287.117.7.7,0,0,1-.209.039.822.822,0,0,1-.636-.228,1.087,1.087,0,0,1,.1-1.409,1.044,1.044,0,0,1,.751-.3,1.012,1.012,0,0,1,.389.095c.177.075.267.163.267.265a.165.165,0,0,1-.041.109.958.958,0,0,0-.027.175c-.007.07-.01.153-.01.248a1.725,1.725,0,0,0,.049.481c0,.01.032.07.08.182a.834.834,0,0,1,.068.172.2.2,0,0,1-.07.153.244.244,0,0,1-.165.061Zm-.437-1.19c0-.036,0-.08.007-.129a1.642,1.642,0,0,1,.024-.163.3.3,0,0,0-.063-.024.2.2,0,0,0-.046-.007.571.571,0,0,0-.42.187.614.614,0,0,0-.18.435.6.6,0,0,0,.085.355.289.289,0,0,0,.255.119.587.587,0,0,0,.206-.036.677.677,0,0,0,.185-.107A5.26,5.26,0,0,1,483.643,187.783Z",
    transform: "translate(-480.187 -186.124)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M491.518,188.887a.97.97,0,0,1-.651-.221.763.763,0,0,1-.277-.615,1.311,1.311,0,0,1,.248-.724.8.8,0,0,1,.656-.427,1.2,1.2,0,0,1,.43.1c.2.08.3.175.3.279a.215.215,0,0,1-.061.153.207.207,0,0,1-.165.073.312.312,0,0,1-.182-.083.511.511,0,0,0-.321-.083c-.09,0-.189.09-.294.267a.907.907,0,0,0-.151.444.349.349,0,0,0,.134.291.52.52,0,0,0,.335.1.645.645,0,0,0,.289-.09.7.7,0,0,1,.216-.09.216.216,0,0,1,.163.068.213.213,0,0,1,.068.158c0,.092-.1.185-.3.274a1.151,1.151,0,0,1-.437.121Z",
    transform: "translate(-486.327 -186.026)",
    fill: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(22.621 9.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M422.579,212.613a.959.959,0,0,1-.136-.015.971.971,0,0,0-.134-.015h-.52c-.044,0-.112,0-.2.015a1.606,1.606,0,0,1-.2.017.183.183,0,0,1-.056-.007.317.317,0,0,0-.056-.007.216.216,0,0,1-.216-.129.646.646,0,0,1-.036-.25.981.981,0,0,1,.146-.551,1.317,1.317,0,0,1,.364-.342l.474-.313a.578.578,0,0,0,.279-.461c0-.044-.036-.09-.112-.134a.42.42,0,0,0-.216-.066.646.646,0,0,0-.4.168.652.652,0,0,1-.287.168.279.279,0,0,1-.163-.046.176.176,0,0,1-.087-.158.239.239,0,0,1,.087-.185,2.012,2.012,0,0,1,.372-.274.992.992,0,0,1,1.025.034.553.553,0,0,1,.282.481.91.91,0,0,1-.138.51,1.187,1.187,0,0,1-.34.325l-.442.277a.689.689,0,0,0-.359.5l.287-.029c.25-.012.43-.019.539-.019a.721.721,0,0,1,.3.066c.121.053.185.124.185.209a.24.24,0,0,1-.236.236Z",
    transform: "translate(-421.02 -209.9)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3158",
    "data-name": "Path 3158",
    d: "M431.221,215.4a.515.515,0,0,1-.257-.158,2.553,2.553,0,0,1-.287.117.7.7,0,0,1-.209.039.822.822,0,0,1-.636-.228,1.087,1.087,0,0,1,.1-1.409,1.044,1.044,0,0,1,.751-.3,1.013,1.013,0,0,1,.389.095c.177.075.267.163.267.265a.165.165,0,0,1-.041.109.954.954,0,0,0-.027.175,2.477,2.477,0,0,0-.01.248,1.722,1.722,0,0,0,.049.481c0,.01.032.07.08.182a.835.835,0,0,1,.068.172.2.2,0,0,1-.07.153.244.244,0,0,1-.165.061Zm-.437-1.19c0-.036,0-.08.007-.129a1.643,1.643,0,0,1,.024-.163.3.3,0,0,0-.063-.024.2.2,0,0,0-.046-.007.571.571,0,0,0-.42.187.614.614,0,0,0-.18.435.6.6,0,0,0,.085.355.289.289,0,0,0,.255.119.587.587,0,0,0,.206-.036.677.677,0,0,0,.185-.107A5.263,5.263,0,0,1,430.783,214.213Z",
    transform: "translate(-427.531 -212.595)",
    fill: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3159",
    "data-name": "Path 3159",
    d: "M340.112,202.122h-.7c-.223,0-.333-.073-.333-.211,0-.158.124-.236.372-.236h.078v-1.564a.539.539,0,0,1-.2.107.245.245,0,0,1-.172-.07.221.221,0,0,1-.073-.165.278.278,0,0,1,.119-.2l.2-.146.216-.172a.438.438,0,0,1,.255-.095c.107,0,.158.063.158.189s0,.338-.017.59-.017.617-.017,1.088v.428h.117a.242.242,0,0,1,.172.066.223.223,0,0,1,0,.325.242.242,0,0,1-.172.066Z",
    transform: "translate(-336.362 -192.335)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3160",
    "data-name": "Path 3160",
    d: "M443.5,181.173a.96.96,0,0,1-.136-.015.973.973,0,0,0-.134-.015h-.52c-.044,0-.112,0-.2.015a1.607,1.607,0,0,1-.2.017.182.182,0,0,1-.056-.007.319.319,0,0,0-.056-.007.216.216,0,0,1-.216-.129.646.646,0,0,1-.036-.25.981.981,0,0,1,.146-.551,1.317,1.317,0,0,1,.364-.342l.474-.313a.578.578,0,0,0,.279-.462c0-.044-.036-.09-.112-.134a.42.42,0,0,0-.216-.066.646.646,0,0,0-.4.168.652.652,0,0,1-.287.168.279.279,0,0,1-.163-.046.176.176,0,0,1-.087-.158.239.239,0,0,1,.087-.185,2.012,2.012,0,0,1,.372-.274.992.992,0,0,1,1.025.034.553.553,0,0,1,.282.481.91.91,0,0,1-.138.51,1.188,1.188,0,0,1-.34.325l-.442.277a.689.689,0,0,0-.359.5l.287-.029c.25-.012.43-.019.539-.019a.721.721,0,0,1,.3.066c.121.053.185.124.185.209a.24.24,0,0,1-.236.236Z",
    transform: "translate(-414.238 -176.504)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3161",
    "data-name": "Path 3161",
    d: "M347.306,199.9h2a.233.233,0,0,0,0-.466h-2a.233.233,0,0,0,0,.466Z",
    transform: "translate(-342.419 -192.381)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3162",
    "data-name": "Path 3162",
    d: "M369.316,188.656h2a.233.233,0,0,0,0-.466h-2a.233.233,0,0,0,0,.466Z",
    transform: "translate(-359.083 -183.871)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    "data-name": "Path 3163",
    d: "M366.706,201.746H402.6a.233.233,0,0,0,0-.466h-35.89a.233.233,0,0,0,0,.466Z",
    transform: "translate(-357.107 -193.781)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    "data-name": "Path 3164",
    d: "M454.366,188.656h2a.233.233,0,0,0,0-.466h-2a.233.233,0,0,0,0,.466Z",
    transform: "translate(-423.475 -183.871)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    "data-name": "Path 3165",
    d: "M397.756,188.656h2a.233.233,0,0,0,0-.466h-2a.233.233,0,0,0,0,.466Z",
    transform: "translate(-380.615 -183.871)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    "data-name": "Path 3166",
    d: "M402.1,186.32v-2a.233.233,0,0,0-.466,0v2a.233.233,0,0,0,.466,0Z",
    transform: "translate(-383.719 -180.767)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M347.486,204.706h2.035a.233.233,0,0,0,0-.466h-2.035a.233.233,0,0,0,0,.466Z",
    transform: "translate(-342.555 -196.022)",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M415.058,173.607l1.472,2.8a.237.237,0,0,0,.427-.056l1.625-4.938c.075-.233.153-.464.228-.7l-.226.172h16.738c.77,0,1.55.034,2.32,0h.034a.233.233,0,0,0,0-.466H420.939c-.77,0-1.55-.034-2.32,0h-.034a.241.241,0,0,0-.226.172l-1.625,4.938c-.075.233-.153.464-.228.7l.427-.056-1.472-2.8c-.141-.267-.544-.032-.4.236h0Z",
    transform: "translate(-393.863 -170.408)",
    fill: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Secure_Server-cuate",
    "data-name": "Secure Server-cuate",
    transform: "translate(164.794 -115.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(191.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3342",
    "data-name": "Path 3342",
    d: "M266.4,87.753H207.446v-.062a10.736,10.736,0,0,1,1.158-21.4,10.58,10.58,0,0,1,1.322.086A12.563,12.563,0,0,1,222.42,55.023a12.245,12.245,0,0,1,5.217,1.158,20.874,20.874,0,0,1,40.318,6.569,12.548,12.548,0,0,1-1.555,25Zm-58.183-.777H266.4a11.77,11.77,0,0,0,1.1-23.486h-.342v-.342a20.089,20.089,0,0,0-38.934-6.282l-.155.4-.389-.194a11.568,11.568,0,0,0-5.255-1.244,11.778,11.778,0,0,0-11.747,11.04v.435l-.428-.078a9.951,9.951,0,1,0-2.332,19.747Z",
    transform: "translate(-197.932 -42.842)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 10.573,
    height: 9.073,
    transform: "translate(35.193 26.835)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3343",
    "data-name": "Path 3343",
    d: "M238.53,74.814h17.834l-8.917-8.894Z",
    transform: "translate(-206.967 -47.979)",
    fill: "#c8102e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(289.587 20.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3344",
    "data-name": "Path 3344",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-144.329 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3576",
    "data-name": "Path 3576",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-155.213 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-166.097 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3578",
    "data-name": "Path 3578",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-176.981 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    "data-name": "Path 3579",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-187.865 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3580",
    "data-name": "Path 3580",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-198.75 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3585",
    "data-name": "Path 3585",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-209.634 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-220.518 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-231.402 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3582",
    "data-name": "Path 3582",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-242.286 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-253.17 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-264.054 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3587",
    "data-name": "Path 3587",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-274.938 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3588",
    "data-name": "Path 3588",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-285.822 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3589",
    "data-name": "Path 3589",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-296.706 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3590",
    "data-name": "Path 3590",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-307.591 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    d: "M329.623,89.027H326.6V88.25h3.024Zm-5.287,0H321.32V88.25h3.016Z",
    transform: "translate(-318.475 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    "data-name": "Path 3345",
    d: "M336.894,90.194h-.777V89.027H334.95V88.25h1.944Z",
    transform: "translate(-147.363 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M337.227,134.5h-.777v-3.11h.777Zm0-5.388h-.777v-3.11h.777Zm0-5.388h-.777v-3.11h.777Zm0-5.388h-.777v-3.11h.777Zm0-5.388h-.777v-3.11h.777Zm0-5.388h-.777v-3.11h.777Zm0-5.388h-.777v-3.11h.777Zm0-5.388h-.777V93.68h.777Z",
    transform: "translate(-147.696 -88.386)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 0.777,
    height: 1.555,
    transform: "translate(188.753 48.426)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    "data-name": "Path 3347",
    d: "M316.122,89.793a1.462,1.462,0,1,1,1.462-1.462,1.462,1.462,0,0,1-1.462,1.462Z",
    transform: "translate(-314.66 -86.87)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3348",
    "data-name": "Path 3348",
    d: "M335.07,150.652a1.462,1.462,0,1,0,1.462-1.462A1.462,1.462,0,0,0,335.07,150.652Z",
    transform: "translate(-147.389 -100.74)",
    fill: "#36333d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(0 31.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3349",
    "data-name": "Path 3349",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-162.69 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-151.806 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-140.922 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-130.038 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-119.154 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3569",
    "data-name": "Path 3569",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-108.27 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3568",
    "data-name": "Path 3568",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-97.386 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3567",
    "data-name": "Path 3567",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-86.501 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    "data-name": "Path 3566",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-75.617 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-64.733 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3574",
    "data-name": "Path 3574",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-53.849 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3573",
    "data-name": "Path 3573",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-42.965 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3572",
    "data-name": "Path 3572",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-32.081 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3571",
    "data-name": "Path 3571",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-21.197 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3570",
    "data-name": "Path 3570",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(-10.313 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3575",
    "data-name": "Path 3575",
    d: "M176.272,89.027h-3.016V88.25h3.016Zm-5.279,0H168V88.25h3.024Z",
    transform: "translate(0.571 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3350",
    "data-name": "Path 3350",
    d: "M163.327,90.194h-.777V88.25h1.944v.777h-1.166Z",
    transform: "translate(-161.477 -87.177)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3351",
    "data-name": "Path 3351",
    d: "M163.327,122.238h-.777V119.3h.777Zm0-5.139h-.777v-2.939h.777Zm0-5.147h-.777v-2.939h.777Zm0-5.139h-.777v-2.939h.777Zm0-5.147h-.777V98.729h.777Zm0-5.139h-.777V93.59h.777v2.939Z",
    transform: "translate(-161.477 -61.933)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M163.327,122.238h-.777V119.3h.777Zm0-5.139h-.777v-2.939h.777Zm0-5.147h-.777v-2.939h.777Zm0-5.139h-.777v-2.939h.777Zm0-5.147h-.777V98.729h.777Zm0-5.139h-.777V93.59h.777v2.939Z",
    transform: "translate(-161.477 -92.253)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 0.777,
    height: 1.555,
    transform: "translate(1.073 62.514)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_332",
    "data-name": "Ellipse 332",
    cx: 1.462,
    cy: 1.462,
    r: 1.462,
    transform: "translate(176.797)",
    fill: "#36333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3352",
    "data-name": "Path 3352",
    d: "M161.17,134.762a1.462,1.462,0,1,0,1.462-1.462A1.462,1.462,0,0,0,161.17,134.762Z",
    transform: "translate(-161.17 -70.771)",
    fill: "#36333d"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataView);
export default __webpack_public_path__ + "static/media/data-view.bd186a51ac0af47160b7b8e55162d9a3.svg";
export { ForwardRef as ReactComponent };